<!-- 设备管理-概览 -->
<template>
  <div class="deviceNew tableloding">
    <div v-if="$store.state.device.isShow == 1" class="deviceNewTable">
      <!-- <span style="color:red;">plantidCur:{{plantidCur.plantidCur}}</span> -->
      <!-- <span style="color:red;">curIsFollow:{{curIsFollow.curIsFollow}}</span> -->
      <div class="devicetop" v-if="plantidCur.plantidCur == '' && !curIsFollow.curIsFollow">
        <!-- <div class="devicename">{{$t('device.deviceList')}}</div> -->
        <ul class="status-container">
          <li v-for="(value, key) in deviceStatusNew" :key="key" class="color" @click="deviceStatusJump(key)"
            v-show="!value.notVisable">
            <div>
              <i class="iconfont" :class="[value.ico, value.color]"></i>
              <span>{{ value.label }}</span>
            </div>
            <div>
              <span class="color-num" :class="value.color">{{
                value.num
              }}</span>
            </div>
            <span class="nibianqi">
              <i class="iconfont icon-a-mingchengnibianqi1" style="opacity: 0.5"></i>
            </span>
            <!-- <span class="statusSpan">
              <span class="color-label" >
                <i class="iconfont" :class="value.ico"></i>
                <i class="status-icon" :class="value.class"></i>
                <span>{{value.label}}</span>
              </span>
              <span class="color-num" :class="value.color">{{value.num}}</span>
            </span>
            <span class="nibianqi" :class="value.color">
              <i class="iconfont" style="opacity:0.5;" :class="value.ico"></i>
                        </span> -->
          </li>
        </ul>
      </div>

      <div class="section">
        <div class="search">
          <div class="searchLeft">
            <span class="search-label">{{ $t("device.device_status") }}</span>
            <el-select v-model="search.status" clearable @change="getDeviceList(true)"
              :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew">
              <el-option v-for="(value, key) in deviceStatus" :key="key" :value="key" :label="value.label"
                style="display: flex; align-items: center">
                <i style="width: 10px; height: 10px; margin-right: 8px" :class="`status-${value.name}`"></i>
                <span class="select-label">{{ value.label }}</span>
              </el-option>
            </el-select>
            <span v-if="vcodeBox != '08'" class="search-label">{{ $t("device.device_type") }}</span>
            <el-select v-model="search.brand" clearable @change="getDeviceList(true)"
              :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew"
              style="width: 120px"
               v-if="vcodeBox != '08'">
              <el-option v-for="item in $filter.deviceType" :key="item.value" :value="item.value"
                :label="item.label"></el-option>
            </el-select>
          </div>
          <div class="searchRight">
            <!-- 搜索 -->
            <!-- showSearch = true; -->
            <el-button class="button button-solid" @click.stop="showSearchBtn">
              <i class="el-icon-search"></i>
            </el-button>
            <!-- 编辑设备控制权限 -->
            <button v-if="this.$store.state.user.role == 1" class="button-solid button buttonDeviceJurisdiction"
              @click="editDeviceControl">
              {{ $t("device.edit_control") }}
              <span class="iconfont icon-a-mingchengshezhi"></span>
            </button>
            <!-- v-clickoutside="closeSearch2" -->
            <div class="search-alert" v-if="this.$store.state.user.role == 1 && showSearch">
              <!-- :placeholder="$t('recharge.pn')" -->
              <!-- v-model="inputText" -->
              <!-- @input实时查询 -->
              <!-- @keyup.enter.native -->
              <div class="searchDiv">
                <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
                  @keyup.enter.native="queryGetDeviceList()" :placeholder="this.$t('device.Sn_deviceName')" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <!-- 搜索 -->
                <span class="search-device" @click="queryGetDeviceList()">{{
                  $t("recharge.Search")
                }}</span>
                <!-- 取消 -->
                <span class="search-hide" @click="closeSearch">{{
                  $t("rate.cancel")
                }}</span>
              </div>
            </div>
            <div class="search-alert1" v-if="this.$store.state.user.role != 1 && showSearch">
              <!-- :placeholder="$t('recharge.pn')" -->
              <!-- v-model="inputText" -->
              <!-- @input实时查询 -->
              <!-- @keyup.enter.native -->
              <div class="searchDiv">
                <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
                  @keyup.enter.native="queryGetDeviceList()"
                  :placeholder="$store.state.user.uidExtra == 4968931 ? 'PN/SN' : this.$t('device.Sn_deviceName')"
                  clearable>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <!-- 搜索 -->
                <span class="search-device" @click="queryGetDeviceList()">{{
                  $t("recharge.Search")
                }}</span>
                <!-- 取消 -->
                <span class="search-hide" @click="closeSearch">{{
                  $t("rate.cancel")
                }}</span>
              </div>
            </div>

            <!-- 导出报表 -->
            <!-- v-show="currentData" -->
            <!-- <button 
              type="button" 
              @click="exportPlant(selectedDevice)" 
              class="button-export"
            >
              {{$t('report.Export_report')}}
              <i class="ico-download"></i>
                        </button> -->
          </div>

          <!-- 批量操作弹条 (显隐由是否勾选决定) -->
          <!-- v-show="showBatch" -->
          <!-- v-show="selectedDevice.length" -->
          <!-- v-show="false" -->
          <div class="batch-alert" v-show="selectedDevice.length">
            <!-- 当前选中条数 -->
            <span class="batch-total">
              {{
                `${$t("alarm.curSelected")} ${selectedDevice.length} ${$t(
                  "alarm._Data"
                )}`
              }}
            </span>
            <div class="batch-right">
              <!-- 操作 -->
              <span class="batch-operate">
                <!-- 导出 -->
                <span class="btn" @click="exportPlant(selectedDevice)">
                  {{ $t("report.Export") }}
                  <i class="ico ico-export"></i>
                </span>

                <!-- v-if="this.$store.state.user.role==1" -->
                <!-- @click="upgradeDevice(selectedDevice)" -->
                <!-- 批量升级查询 -->
                <span v-if="this.$store.state.user.role == 1" class="btn" @click="queryUpgradeDevice(selectedDevice1)">
                  {{ $t("device.queryUpgrade") }}
                  <i class="ico el-icon-search"></i>
                </span>
                <!-- 升级(管理员可批量升级) -->
                <span v-if="this.$store.state.user.role == 1" class="btn" @click="upgradeDeviceBatch(selectedDevice)">
                  {{ $t("device.upgrade") }}
                  <i class="ico ico-upgrade"></i>
                </span>
                <!-- 删除(暂时注释，接口待开发) -->
                <!-- <span 
                  class="btn"
                  @click="deleteDevice(selectedDevice)"
                >
                  {{$t('device.delete')}}
                  <i class="ico ico-clear"></i>
                            </span> -->
              </span>
              <!-- 取消 -->
              <span class="batch-hide" @click="closeBatch">{{
                $t("rate.cancel")
              }}</span>
            </div>
          </div>
        </div>

        <!-- <div class="title">{{$t('device.deviceList')}}</div> -->
        <!-- <div class="table"> -->
        <el-table :data="deviceList" border stripe height="100%" :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
          :header-cell-style="{
            background: 'rgb(65, 80, 90)',
            color: '#ffffff',
          }" :empty-text="$t('message.nodata')" v-loading="loadingDevice" element-loading-spinner="el-icon-loading"
          class="tablemain tableloding" @selection-change="changeFun" ref="multipleSnTable" :cell-class-name="addClass">
          <el-table-column fixed type="selection"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" fixed min-width="110px;" :label="$t('device.device_name')"
            style="position: relative">
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <span class="redirect" @click="enterDevice(scope.row)" :title="scope.row.devalias || scope.row.sn">{{
                scope.row.devalias || scope.row.sn }}</span>
              <!-- 关注标记(暂时注释) -->
              <!-- <span
                  v-show="scope.row.focus"
                  class="followSign" 
                  style="position:absolute;top:0px;right:0px;"
                            ></span> -->
            </template>
          </el-table-column>
          <el-table-column min-width="100px;" :show-overflow-tooltip="true" :label="$t('device.device_sn')">
            <template slot-scope="scope">
              <span :title="scope.row.deviceSn||scope.row.sn || '--'">{{
                scope.row.deviceSn || scope.row.sn || "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" min-width="120px;" :show-overflow-tooltip="true"
            :label="$t('device.device_status')">
            <template slot-scope="scope">
              <div :class="`background-${$filter.deviceStatus[scope.row.status].name
                }`" style="border-radius: 5px">
                <span :class="`radius-${$filter.deviceStatus[scope.row.status].name
                  }`" style="
                    width: 8px;
                    height: 8px;
                    border-radius: 8px;
                    display: inline-block;
                    margin-right: 5px;
                  "></span>
                <span v-if="scope.row.status !== undefined" :class="`color-${$filter.deviceStatus[scope.row.status].name
                  }`">{{
                    $filter.deviceStatus[scope.row.status].label || "--"
                  }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
              prop="brand"
              :show-overflow-tooltip="true"
              :label="$t('device.device_type')"
            >
              <template slot-scope="scope">
                {{scope.row.brand | translateDeviceType}}
              </template>
                        </el-table-column>-->
          <el-table-column prop="devaddr" min-width="130px;" :show-overflow-tooltip="true"
            :label="$t('device.device_address')"
            v-if="!(vcodeBox == '08' || $store.state.user.riyueyuanPermissionMark)"></el-table-column>
          <el-table-column min-width="115px;" :show-overflow-tooltip="true" :label="$t('device.device_type')"
            v-if="!(vcodeBox == '08' || $store.state.user.riyueyuanPermissionMark)">
            <template slot-scope="scope">
              <span v-if="scope.row.brand >= 0 && scope.row.brand <= 4"
                :title="$filter.deviceType[scope.row.brand].label">{{ $filter.deviceType[scope.row.brand].label
                }}</span>
              <span v-else :title="'--'">{{ "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="devcode" min-width="90px;" :show-overflow-tooltip="true"
            :label="$t('device.device_code')"
            v-if="!((vcodeBox == '08' || $store.state.user.riyueyuanPermissionMark) && $store.state.user.role == 2)"></el-table-column>
          <el-table-column prop="pn" min-width="135px;" :show-overflow-tooltip="true"
            :label="$t('device.datalogger_pn')"
            v-if="!((vcodeBox == '08' || $store.state.user.riyueyuanPermissionMark) && $store.state.user.role == 2)"></el-table-column>

          <el-table-column v-if="vcodeBox && vcodeBox != '08'" min-width="140px;" :show-overflow-tooltip="true"
            :label="$t('device.coll_alias')">
            <template slot-scope="scope">
              <span :title="scope.row.collalias || '--'">{{
                scope.row.collalias || "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120px;" :show-overflow-tooltip="true" :label="$t('device.User_belong')">
            <template slot-scope="scope">
              <span class="redirect" @click="enterDevice(scope.row)" :title="scope.row.usr || '--'">{{ scope.row.usr ||
                "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="this.$t('device.Operation')" width="300px" class="fixedRgiht">
            <template slot-scope="scope">
              <el-button v-if="vcodeBox == '08'" :disabled="scope.row.usr ? false : true" type="text" class="operation"
                :class="{ operation1: scope.row.usr == undefined }" :title="$t('datalogger.unbind')"
                @click="unbindDatalogger(scope.row.pn)">
                <i class="iconfont icon-a-mingchengyonghushuxingshanchu2"></i>
              </el-button>
              <el-button v-if="vcodeBox == '08'" type="text" class="operation" :disabled="scope.row.usr ? false : true"
                :class="{ operation1: scope.row.usr == undefined }" :title="$t('account.resetPwd')"
                @click="resetpwd(scope.row)">
                <i class="iconfont icon-caozuo_zhongzhimima"></i>
              </el-button>
              <el-button v-if="
                vcodeBox != '08' ||
                (vcodeBox == '08' && $store.state.user.role != 2)
              " type="text" class="operation" :title="$t('device.edit')" @click="editDevice(scope.row)">
                <i class="iconfont icon-bianji"></i>
              </el-button>
              <el-button v-if="
                vcodeBox != '08' ||
                (vcodeBox == '08' && $store.state.user.role != 2)
              " type="text" class="operation" :title="$t('device.debug')" @click="debugDevice(scope.row)">
                <i class="iconfont icon-tiaoshi1"></i>
              </el-button>
              <el-button v-if="
                vcodeBox != '08' ||
                (vcodeBox == '08' && $store.state.user.role != 2)
              " type="text" class="operation" :title="$t('device.control')" @click="controlDevice(scope.row)">
                <i class="iconfont icon-caozuo_kongzhi"></i>
              </el-button>
              <el-button v-if="
                vcodeBox != '08' ||
                (vcodeBox == '08' && $store.state.user.role != 2)
              " type="text" class="operation" :title="$t('device.upgrade1')" @click="upgradeDevice(scope.row)">
                <i class="iconfont icon-caozuo_shengji"></i>
              </el-button>
              <el-button v-if="
                vcodeBox == '08' && $store.state.user.role == 1 && scope.row.otaLabel == 1
              " type="text" class="operation" :title="$t('menu.intelligenceUpgrade')" @click="intelligenceUpgrade(scope.row)">
                <i class="iconfont icon-a-mingchengyunshangchuan3"></i>
              </el-button>
              <el-button v-if="
                vcodeBox != '08' ||
                (vcodeBox == '08' && $store.state.user.role != 2)
              " type="text" class="operation" :title="$t('report.Export_report')" @click="exportPlant([scope.row])">
                <i class="iconfont icon-baobiao"></i>
              </el-button>
              <el-button v-if="vcodeBox == '08' && $store.state.user.role == 2" type="text" class="operation"
                :title="$t('device.more')" @click="moreDevice(scope.row)">
                <i class="iconfont icon-zidingyi1"></i>
              </el-button>

              <!-- <el-button
                  type="text"
                  class="operation"
                  :title="$t('device.delete')"
                  @click="deleteDevice(scope.row)"
                >
                  <i class="iconfont icon-caozuo_shanchu"></i>
                            </el-button> -->
            </template>
          </el-table-column>
          <!-- 暂无数据 -->
          <div v-show="emptyText" slot="empty">
            <!-- <img src="@/assets/img/empty_text.png" /> -->
            <div style="line-height: 32px">{{ $t("account.nodata") }}</div>
          </div>
        </el-table>
        <!-- </div> -->
        <div class="tablebottom">
          <!-- 批量占位 -->
          <div class="" style="margin-left: 10px">
            <!-- 批量导出 -->
            <!-- <button
              type="button" 
              style="height:32px;margin-right:8px;"
              class="btn"
              :class="selectedDevice.length ? 'btn-dark' : 'btn-disable'"
              @click="exportPlant(selectedDevice)"
                        >{{$t('report.Batch_export')}}</button> -->
            <!-- 批量删除 (是否有批量删除设备) -->
            <!-- @click="deleteDatalogger(selectedDevice)" -->
            <!-- <button
              type="button" 
              style="height:32px;margin-right:8px;"
              class="btn"
              :class="selectedDevice.length ? 'btn-dark' : 'btn-disable'"
                        >{{$t('alarm.Delete_selected')}}</button> -->
          </div>
          <!-- 分页 -->
          <el-pagination class="pagination" background @size-change="getDeviceList(true)"
            @current-change="() => getDeviceList()" :current-page.sync="pagination.currentPage"
            :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
            layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
            <span style="color: #ffffff; padding-left: 15px">{{ $t("device.pageSize") }} :</span>
          </el-pagination>
        </div>

        <!-- 导出报表 -->
        <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>
        <!--解绑数采器-->
        <device-dialog :title="$t('datalogger.unbindDataloggerName')" :class="{
          showDialog: unbindDataloggerVisible,
          hideDialog: !unbindDataloggerVisible,
        }" :visible.sync="unbindDataloggerVisible" noFooter>
          <div slot="content">
            <div style="font-size: 16px; color: #dd6843">
              {{ $t("datalogger.unbindDataloggerExplain") }}
            </div>
            <div style="color: #d9e2e6; font-size: 14px; margin: 10px 0 20px">
              <span>{{ $t("recharge.DataloggerPN") }}</span>
              <span>{{ this.resetDataloggerPn }}</span>
            </div>
            <el-input style="margin-bottom: 30px" v-model="resetDataloggerCode"
              :placeholder="$t('datalogger.unbindTitle')"></el-input>
            <div style="text-align: right">
              <button class="btn btn-light" style="
                  margin-right: 10px;
                  color: #dd6843;
                  border: 1px solid #dd6843;
                " @click="unbindDataloggerVisible = false">
                {{ $t("device.cancel") }}
              </button>
              <button style="background: #dd6843" class="btn btn-dark" @click="unbindDataloggerConfirm()">
                {{ $t("datalogger.unbind") }}
              </button>
            </div>
          </div>
          <div slot="footer"></div>
        </device-dialog>
        <!-- 解绑数采器结果提示(成功) -->
        <!-- v-if="dataloggerEditSucVisible" -->
        <device-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindSucVisible" :class="{
          showDialog: dataloggerUnbindSucVisible,
          hideDialog: !dataloggerUnbindSucVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{
                $t("datalogger.unbindSuc")
              }}</span>
              <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button type="button" class="btn btn-dark" @click="
                  dataloggerUnbindSucVisible = false;
                queryGetDeviceList();
                ">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 解绑数采器结果提示(失败) -->
        <!-- v-if="dataloggerEditFailVisible" -->
        <device-dialog :title="$t('datalogger.unbindResults')" :visible.sync="dataloggerUnbindFailVisible" :class="{
          showDialog: dataloggerUnbindFailVisible,
          hideDialog: !dataloggerUnbindFailVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ dataloggerTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button type="button" class="btn btn-dark" @click="dataloggerUnbindFailVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 重置密码 -->
        <update-dialog :title="$t('account.resetPwd')" :visible.sync="showResetpwdDialog" :width="'500px'"
          v-if="showResetpwdDialog" noFooter>
          <el-form slot="content" class="chongzhi grid" ref="resetform" :model="resetform" :rules="resetRules">
            <el-form-item :label="$t('account.accountName1')" prop="usr">
              <el-input :value="resetform.usr" auto-complete="off" disabled>
                <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('account.newPwd1')" prop="newpwd">
              <el-input v-model.trim="resetform.newpwd" :placeholder="$t('account.newPwd')" type="text" class="password"
                clearable @clear="pwdcheck" @input.native="NewPasswordlevel"
                @keyup.enter.native="$refs.resetconfPwd.focus()">
                <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
              </el-input>
              <div class="inputlo">
                <div :class="passpwdError ? 'pwd_span' : 'sucess'" v-show="!strength">
                  <span>{{ pwdtip }}</span>
                </div>
                <div class="input_span" v-show="strength">
                  <span style="font-size: 12px; font-weight: bold">{{
                    $t("signup.qiangdu")
                  }}</span>
                  <span class="juxing" ref="NewPasswordlevel"></span>
                  <span style="font-size: 12px; font-weight: bold; margin-left: 5px">{{ count }}</span>
                </div>
                <!-- <span>{{usrtip}}</span> -->
              </div>
            </el-form-item>
            <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
              <el-input v-model.trim="resetform.confPwd" :placeholder="$t('account.confirmpassword')" type="text"
                class="password" clearable ref="resetconfPwd" @keyup.enter.native="resetpwdold">
                <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
              </el-input>
              <div class="inputlo">
                <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
                  <span>{{ confpwdtip }}</span>
                </div>
              </div>
            </el-form-item>
            <!-- Grid占位 -->
            <div></div>
            <div style="text-align: right">
              <button type="button" class="btn btn-dark" @click="resetpwdold">
                {{ $t("account.confirm") }}
              </button>
              <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
            </div>
          </el-form>
        </update-dialog>
        <!-- 重置密码结果提示(成功) -->
        <!-- v-if="resetPwdSucVisible" -->
        <device-dialog :title="$t('account.resetPwd')" :visible.sync="resetPwdSucVisible" :class="{
          showDialog: resetPwdSucVisible,
          hideDialog: !resetPwdSucVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{
                $t("account.resetPwdSuc")
              }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="resetPwdSucVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 重置密码结果提示(失败) -->
        <!-- v-if="resetPwdFailVisible" -->
        <device-dialog :title="$t('account.resetPwd')" :visible.sync="resetPwdFailVisible" :class="{
          showDialog: resetPwdFailVisible,
          hideDialog: !resetPwdFailVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="resetPwdFailVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        
        <!-- 智能升级 -->
        <device-dialog :class="{
          showDialog: intelligenceUpgradeVisible,
          hideDialog: !intelligenceUpgradeVisible,
        }" :title="$t('menu.intelligenceUpgrade')" :visible.sync="intelligenceUpgradeVisible" width="580px" noFooter>
          <div slot="content">
            <el-form class="grid upload-container upgradeNew" element-loading-spinner="el-icon-loading"
              v-loading="loadingupgradeDev">
              <el-form-item label=" ">
                <div v-if="!progressUp&&!progerssComplete&&intelligenceUpgradeInfo.needConfirm&&intelligenceUpgradeInfo.confirmMessage">{{ intelligenceUpgradeInfo.confirmMessage }}</div>
                <div v-else-if="!progressUp&&!progerssComplete&&!intelligenceUpgradeInfo.needConfirm">{{ $t("menu.intelligenceUpgradeTitle1") }}</div>
                <div class="progressShowEquipment">
                  <div class="processstatueEquipment" v-show="progressUp">
                    {{ $t("firmware.upgrading") }}
                  </div>
                  <div :class="progressFlag == 0
                    ? 'processstatueEquipment'
                    : 'processstatueEquipment1'
                    " v-show="progerssComplete">
                    {{ resultTitle }}
                  </div>
                </div>
                <div class="processDataEquipment" v-show="progressUp">
                  <el-progress :format="progressText" :percentage="progress" :stroke-width="10"
                    color="#33FFB6"></el-progress>
                </div>
                <div class="progerssCompleteEquipment" v-show="upgradeDeviceBatchSign == true">
                  <div style="
                      margin-bottom: 10px;
                      display: flex;
                      justify-content: flex-start;
                    ">
                    <div>
                      <!-- 升级成功的设备： -->
                      <div style="color: #16d09a">
                        {{ $t("device.upSuccessDevice") }}：
                      </div>
                      <div>
                        <span v-for="(item, index) in snUpOkList" :key="index" style="
                            margin-right: 5px;
                            max-height: 100px;
                            max-width: 200px;
                            overflow: hidden;
                            overflow-y: scroll;
                            display: flex;
                            flex-direction: column;
                          ">{{ `${item},` }}</span>
                      </div>
                    </div>
                    <div style="margin-left: 10px">
                      <!-- 升级失败的设备： -->
                      <div style="color: rgb(255, 62, 62)">
                        {{ $t("device.upFailDevice") }}：
                      </div>
                      <div>
                        <span v-for="(item, index) in snUpNoList" :key="index" style="
                            margin-right: 5px;
                            max-height: 100px;
                            max-width: 200px;
                            overflow: hidden;
                            overflow-y: scroll;
                            display: flex;
                            flex-direction: column;
                          ">{{ `${item},` }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 固件名称(上面已存在) -->
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{firmwareName}}
                              </div> -->
                  <!-- <div class="progressCancel"></div> -->
                </div>
                <div class="progerssCompleteEquipment" v-show="progerssComplete && upgradeDeviceBatchSign != true">
                  <div class="progressCancel"></div>
                </div>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <button v-show="!progressUp" class="btn btn-light" @click="intelligenceUpgradeVisible = false" style="margin-right:10px">{{$t('device.cancel')}}</button>
              <button style="margin-right: 20px" v-show="progressUp" class="btn btn-dark" @click="upgradeCancel">
                {{ $t("firmware.upgrade_quit6") }}
              </button>
              <!-- 批量升级 -->
              <button v-if="upgradeDeviceBatchSign == true" class="btn btn-dark" @click="submitUpgradeDeviceBatch">
                {{ $t("device.confirm") }}
              </button>
              <!-- 单个升级 -->
              <el-button v-else-if="progressUp" class="elbtn btn-dark" :disabled="upgradebButtonStatus" @click="intelligenceUpgradeVisible=false">{{
                $t("device.confirm") }}</el-button>
              <el-button v-else-if="resultTitle==$t('firmware.updateCompleted')&&!progressUp" class="elbtn btn-dark" :disabled="upgradebButtonStatus" @click="intelligenceUpgradeVisible = false">{{
                $t("device.confirm") }}</el-button>
              <el-button v-else class="elbtn btn-dark" :disabled="upgradebButtonStatus" @click="submitIntelligenceUpgradeDevice">{{
                $t("device.confirm") }}</el-button>
            </div>
          </div>
          <div slot="footer">
            <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
            <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
          </div>
        </device-dialog>
        <!-- 编辑设备 -->
        <!-- v-if="editDeviceVisible" -->
        <device-dialog :title="$t('device.modify_alias')" :visible.sync="editDeviceVisible" :class="{
          showDialog: editDeviceVisible,
          hideDialog: !editDeviceVisible,
        }" noFooter>
          <div slot="content">
            <el-form class="grid">
              <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
                <!-- 展示取deviceSn(缺失时回退sn)，提交给后端仍用formEdit.sn，故此处只读单向绑定 -->
                <el-input :value="formEdit.deviceSn || formEdit.sn" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
                <el-input v-model="formEdit.devalias" clearable></el-input>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <!-- <button
                class="button-hollow"
                @click="editDeviceVisible = false"
                          >{{$t('device.cancel')}}</button>-->
              <button class="btn btn-dark" @click="submitEditDevice">
                {{ $t("device.confirm") }}
              </button>
            </div>
          </div>
          <div slot="footer">
            <!-- <button
              class="button-hollow"
              @click="editDeviceVisible = false"
                        >{{$t('device.cancel')}}</button>-->
            <!-- <button 
              class="button-solid" 
              @click="submitEditDevice"
                        >{{$t('device.confirm')}}</button> -->
          </div>
        </device-dialog>
        <!-- 修改设备结果提示(成功) -->
        <!-- v-if="editDeviceSucVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible" :class="{
          showDialog: editDeviceSucVisible,
          hideDialog: !editDeviceSucVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t("project.editSuc") }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="editDeviceSucVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 修改设备结果提示(失败) -->
        <!-- v-if="editDeviceFailVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible" :class="{
          showDialog: editDeviceFailVisible,
          hideDialog: !editDeviceFailVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="editDeviceFailVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 更多操作 -->
        <el-dialog :title="$t('device.more')" :visible.sync="moreDeviceVisible" :z-index="1000"
          custom-class="moreDeviceDialog" :class="{
            showDialog: moreDeviceVisible,
            hideDialog: !moreDeviceVisible,
          }" noFooter>
          <div>
            <div style="
                background-color: rgba(43, 63, 75);
                padding: 10px 20px;
                border-radius: 10px;
                margin-bottom: 20px;
                color: #fff;
              ">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>SN：</span>
                <span>{{ this.moreDeviceInfo.deviceSn||this.moreDeviceInfo.sn }}</span>
              </div>
              <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>PN：</span>
                <span>{{ this.moreDeviceInfo.pn }}</span>
              </div>
              <!-- <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>{{ $t("device.device_address") }}：</span>
                <span>{{ this.moreDeviceInfo.devaddr }}</span>
              </div>
              <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>{{ $t("device.device_type") }}：</span>
                <span v-if="moreDeviceInfo.brand >= 0 && moreDeviceInfo.brand <= 4"
                  :title="$filter.deviceType[moreDeviceInfo.brand].label">{{
                    $filter.deviceType[moreDeviceInfo.brand].label
                  }}</span>
                <span v-else :title="'--'">{{ "--" }}</span>
              </div> -->
              <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>{{ $t("device.device_code") }}：</span>
                <span>{{ this.moreDeviceInfo.devcode }}</span>
              </div>
              <div style="
                  display: flex;
                  justify-content: space-between;
                  border-bottom: 1px solid #116863;
                  padding: 5px 0 5px;
                  align-items: center;
                ">
                <span>{{ $t("device.Operation") }}：</span>
                <div class="btnbox">
                  <el-button size="mini" :disabled="moreDeviceInfo.sn == undefined
                    ? true
                    : moreDeviceInfo.sn == ''
                      ? true
                      : false
                    " class="el-btn btn-dark" style="margin-right: 10px" @click="moreEditDevice(moreDeviceInfo)">
                    {{ $t("device.edit") }}
                  </el-button>
                  <el-button size="mini" :disabled="moreDeviceInfo.sn == undefined
                    ? true
                    : moreDeviceInfo.sn == ''
                      ? true
                      : false
                    " class="el-btn btn-dark" style="margin-right: 10px" @click="moreControlDevice(moreDeviceInfo)">
                    {{ $t("device.control") }}
                  </el-button>
                  <el-button size="mini" :disabled="moreDeviceInfo.sn == undefined
                    ? true
                    : moreDeviceInfo.sn == ''
                      ? true
                      : false
                    " class="el-btn btn-dark" style="margin-right: 10px" @click="moreUpgradeDevice(moreDeviceInfo)">
                    {{ $t("device.upgrade1") }}
                  </el-button>
                  <el-button size="mini" :disabled="moreDeviceInfo.sn == undefined
                    ? true
                    : moreDeviceInfo.sn == ''
                      ? true
                      : false
                    " class="el-btn btn-dark" style="margin-right: 10px" @click="moreExportPlant([moreDeviceInfo])">
                    {{ $t("report.Export_report") }}
                  </el-button>
                  <el-button size="mini" :disabled="moreDeviceInfo.sn == undefined
                    ? true
                    : moreDeviceInfo.sn == ''
                      ? true
                      : false
                    " class="el-btn btn-dark" @click="moreOwnerShip([moreDeviceInfo])">
                    {{ $t("device.ownerShip") }}
                  </el-button>
                </div>
              </div>
              <!-- <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>{{ $t('device.control') }}：</span>
                <button class="btn btn-dark" @click="moreControlDevice(moreDeviceInfo)">{{ $t('device.confirm') }}</button>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>{{ $t('device.upgrade1') }}：</span>
                <button class="btn btn-dark" @click="moreUpgradeDevice(moreDeviceInfo)">{{ $t('device.confirm') }}</button>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>{{ $t('report.Export_report') }}：</span>
                <button class="btn btn-dark" @click="moreExportPlant([moreDeviceInfo])">{{ $t('device.confirm') }}</button>
              </div> -->
            </div>
            <!-- <div v-if="this.moreDeviceInfo.usr" style="background-color:rgba(43,63 ,75) ;padding: 10px 20px;border-radius: 10px;">
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>所属用户：</span>
                <span>{{this.moreDeviceInfo.usr}}</span>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>重置密码：</span>
                <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>删除用户：</span>
                <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>禁用账号：</span>
                <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
              </div>
              <div style="display: flex;justify-content: space-between;    border-bottom: 1px solid #116863;padding:5px 0 5px;align-items: center;">
                <span>分配数采器：</span>
                <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
              </div>
            </div> -->
          </div>
          <!-- 业主变更 -->
          <device-dialog :title="$t('device.modify_alias')" :visible.sync="moreOwnerShipVisible" :class="{
            showDialog: moreOwnerShipVisible,
            hideDialog: !moreOwnerShipVisible,
          }" noFooter>
            <div slot="content">
              <el-form class="grid">
                <el-form-item :label="$t('device.serial_number')" prop="pn" size="small">
                  <!-- 展示取deviceSn(缺失时回退sn)，deviceSn仅展示；提交走pn/uid，不含sn -->
                  <el-input :value="formOwnerShip.deviceSn || formOwnerShip.sn" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('device.oldOwner')" prop="pn" size="small">
                  <el-input v-model="formOwnerShip.usr" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('device.nweOwner')" prop="newUid" size="small">
                  <el-select
                    popper-class="select-search-recharge"
                    ref="ownerSelectRef"
                    v-model="newOwnerName"
                    :placeholder="$t('header.pleaseSelect')"
                    filterable
                    :loading="ownerLoading"
                    @visible-change="handleOwnerSelectVisibleChange"
                    @change="handleOwnerSelectChange"
                  >
                    <el-option
                      v-for="item in ownerSelectList"
                      :key="item.usr"
                      :label="item.usr"
                      :value="item.uid"
                    />
                    <el-option
                      v-if="hasMoreOwner && ownerSelectList.length > 0"
                      disabled
                      :label="ownerLoading ? $t('device.loading') : $t('device.moreLoading')"
                      value=""
                    />
                  </el-select>
                </el-form-item>
              </el-form>
              <div style="text-align: right">
                <button class="btn btn-dark" @click="subbmitOwnerShip">
                  {{ $t("device.confirm") }}
                </button>
              </div>
            </div>
            <div slot="footer">
            </div>
          </device-dialog>
          <!-- 编辑设备 -->
          <!-- v-if="editDeviceVisible" -->
          <device-dialog :title="$t('device.modify_alias')" :visible.sync="moreEditDeviceVisible" :class="{
            showDialog: moreEditDeviceVisible,
            hideDialog: !moreEditDeviceVisible,
          }" noFooter>
            <div slot="content">
              <el-form class="grid">
                <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
                  <!-- 展示取deviceSn(缺失时回退sn)，提交给后端仍用formEdit.sn，故此处只读单向绑定 -->
                  <el-input :value="formEdit.deviceSn || formEdit.sn" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
                  <el-input v-model="formEdit.devalias" clearable></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: right">
                <!-- <button
                  class="button-hollow"
                  @click="editDeviceVisible = false"
                            >{{$t('device.cancel')}}</button>-->
                <button class="btn btn-dark" @click="submitEditDevice">
                  {{ $t("device.confirm") }}
                </button>
              </div>
            </div>
            <div slot="footer">
              <!-- <button
                class="button-hollow"
                @click="editDeviceVisible = false"
                          >{{$t('device.cancel')}}</button>-->
              <!-- <button 
                class="button-solid" 
                @click="submitEditDevice"
                          >{{$t('device.confirm')}}</button> -->
            </div>
          </device-dialog>
          <!-- 修改设备结果提示(成功) -->
          <!-- v-if="editDeviceSucVisible" -->
          <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible" :class="{
            showDialog: editDeviceSucVisible,
            hideDialog: !editDeviceSucVisible,
          }" width="500px" noFooter>
            <div slot="content">
              <div class="showresultbox">
                <span class="showbase showsuccess"></span>
                <span class="showresulttext">{{ $t("project.editSuc") }}</span>
                <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
                <!-- 确定 -->
                <div class="showoperate">
                  <button class="btn btn-dark" @click="editDeviceSucVisible = false">
                    {{ $t("datalogger.confirm") }}
                  </button>
                </div>
              </div>
            </div>
          </device-dialog>
          <!-- 修改设备结果提示(失败) -->
          <!-- v-if="editDeviceFailVisible" -->
          <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible" :class="{
            showDialog: editDeviceFailVisible,
            hideDialog: !editDeviceFailVisible,
          }" width="500px" noFooter>
            <div slot="content">
              <div class="showresultbox">
                <span class="showbase showfail"></span>
                <span class="showresulttext">{{ deviceTipMsg }}</span>
                <!-- 确定 -->
                <div class="showoperate">
                  <button class="btn btn-dark" @click="editDeviceFailVisible = false">
                    {{ $t("datalogger.confirm") }}
                  </button>
                </div>
              </div>
            </div>
          </device-dialog>
          <!-- 控制项 -->
          <!-- v-if="controlDeviceVisible" -->
          <device-dialog :title="$t('device.control')" append-to-body :z-index="9999"
            custom-class="moreChildDeviceDialog" :width="'1000px'" style="padding: 0 35px 36px"
            :visible.sync="moreControlDeviceVisible" :class="{
              showDialog: moreControlDeviceVisible,
              hideDialog: !moreControlDeviceVisible,
            }" noFooter>
            <div @click="clickClosePicker()" class="control" slot="content">
              <div v-if="vcodeBox == '08'" style="width: 100%; text-align: right; padding-right: 40px">
                <el-button v-loading="oneClickReadFlag" style="
                    height: 30px;
                    color: #fff;
                    background-color: rgba(23, 194, 133, 0.5);
                  " @click="oneClickRead()" class="submit-control btn btn-dark">
                  {{ $t("device.one_click_read") }}
                </el-button>
              </div>
              <div v-if="tableDataBse.length">
                <div class="tableTitle">
                  {{ $t("createPlant.basic_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataBse" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataStd.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Standard_setting") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataStd" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataSvs.length">
                <div class="tableTitle">
                  {{ $t("createPlant.System_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataPvs.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Solar_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')" style="background-color: #fff">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataGrd.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Grid_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')" style="padding: 0">
                    <template slot-scope="scope">
                      <div style="padding: 0" class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-if="tableDataBat.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Battery_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataBat" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataCts.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Control_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataCts" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataLos.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Load_setting") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataLos" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataBas.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Basic_setting") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataBas" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataAdv.length">
                <div class="tableTitle">
                  {{ $t("createPlant.Advanced_setting") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="tableDataElse.length">
                <div class="tableTitle">
                  {{ $t("createPlant.other_settings") }}
                </div>
                <el-table class="tableBackgruond" :data="tableDataElse" stripe border :empty-text="$t('message.nodata')"
                  :cell-style="OperationStyle">
                  <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                  <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')" min-width="160px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                        popper-class="select-search-recharge">
                        <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                      <div @click.stop v-else-if="
                        scope.row.id === 'system_time' ||
                        scope.row.id === 'sys_system_time'
                      ">
                        <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                          :editable="false" :append-to-body="false" type="datetime"
                          :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                          :placeholder="'yyyy-MM-dd HH:mm:ss'">
                        </el-date-picker>
                      </div>
                      <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                        :placeholder="scope.row.hint"></el-input>
                      <el-input v-model="scope.row.controlvalue" v-else></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" :label="$t('device.Operation')">
                    <template slot-scope="scope">
                      <div class="instructieClass">
                        <el-button v-loading="scope.row.isLoading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-shuaxin"></i>
                          <span>{{ $t("device.read") }}</span>
                        </el-button>
                        <el-button v-loading="scope.row.Loading" style="
                            color: #fff;
                            background-color: rgba(23, 194, 133, 0.5);
                          " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                          <i class="iconfont icon-caozuo_tiaoshi"></i>
                          <span>{{ $t("device.distribute") }}</span>
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 无数据 -->
              <div v-if="noDataControl">
                <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
                  <el-table-column :label="$t('device.Field_Name')"></el-table-column>
                  <el-table-column :label="$t('device.Unit')"></el-table-column>
                  <el-table-column :label="$t('device.set')"></el-table-column>
                  <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
                </el-table>
              </div>
            </div>
          </device-dialog>
          <!-- 固件升级 -->
          <!-- v-if="upgradeDeviceVisible" -->
          <device-dialog :class="{
            showDialog: moreUpgradeDeviceVisible,
            hideDialog: !moreUpgradeDeviceVisible,
          }" :title="$t('device.device_upgrade')" :visible.sync="moreUpgradeDeviceVisible" width="580px" noFooter>
            <div slot="content">
              <el-form class="grid upload-container upgradeNew" element-loading-spinner="el-icon-loading"
                v-loading="loadingupgradeDev">
                <!-- 批量升级提示(注意国际化) -->
                <el-form-item label=" ">
                  <!-- 注意：批量升级是给多个设备升级同一个设备固件，如不清楚设备所适合的固件，请谨慎选择！ -->
                  <span v-if="upgradeDeviceBatchSign == true" style="color: rgba(255, 62, 62, 1); font-size: 14px">{{
                    $t("device.upBatchDeviceTip") }}</span>
                </el-form-item>
                <el-form-item :label="$t('device.select_firmware')" size="small">
                  <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
                    :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                    <template slot="empty">
                      <div style="text-align: right">
                        <!-- <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button> -->
                        <button class="upFirewareBtn" @click="uploadFirmwareAdd()">
                          {{ $t("firmware.Upload_firmware") }}
                        </button>
                      </div>
                    </template>
                    <div style="text-align: right">
                      <!-- <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button> -->
                      <button class="upFirewareBtn" @click="uploadFirmwareAdd()">
                        {{ $t("firmware.Upload_firmware") }}
                      </button>
                    </div>
                    <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('device.firmware_type')" size="small">
                  <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype"
                    :placeholder="$t('device.select_type')" popper-class="select-search-recharge">
                    <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype"
                    :placeholder="$t('device.select_type')" popper-class="select-search-recharge">
                    <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('device.upgrade_brate')" size="small">
                  <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label=" ">
                  <!-- 原上传按钮 -->
                  <!-- <div class="upload-contents">
                    <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                      <i class="iconfont icon-shangchuan"></i>
                      {{$t('device.Upload')}}
                    </button>
                    <div class="upload-tip">{{$t('firmware.limit')}}</div>
                              </div> -->
                  <div class="progressShowEquipment">
                    <div class="processstatueEquipment" v-show="progressUp">
                      {{ $t("firmware.upgrading") }}
                    </div>
                    <div :class="progressFlag == 0
                      ? 'processstatueEquipment'
                      : 'processstatueEquipment1'
                      " v-show="progerssComplete">
                      {{ resultTitle }}
                    </div>
                    <!-- <div class="progressName">
                      <i class="iconfont icon-fujian"></i>
                      {{ firmwareName }}
                    </div>
                    <div class="progressCancel" @click="upgradeCancel">
                      <i class="iconfont icon-delete"></i>
                    </div> -->
                  </div>
                  <div class="processDataEquipment" v-show="progressUp">
                    <el-progress :format="progressText" :percentage="progress" :stroke-width="10"
                      color="#33FFB6"></el-progress>
                    <!-- <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div> -->
                  </div>
                  <!-- 原上传按钮 -->
                  <!-- <input
                    type="file"
                    class="upload-input"
                    ref="fileUploader"
                    accept="application/octet-stream"
                    @change="uploadfile($event)"
                              /> -->
                  <!-- 暂时注释显隐条件 -->
                  <!-- v-show="progerssComplete" -->
                  <div class="progerssCompleteEquipment" v-show="upgradeDeviceBatchSign == true">
                    <!-- <div class="progressName">
                      <i class="iconfont icon-fujian"></i>
                      {{ firmwareName }}
                    </div> -->
                    <!-- <div class="progressCancel"></div> -->
                    <!-- 增：已完成升级的设备SN(注意国际化) -->
                    <div style="
                        margin-bottom: 10px;
                        display: flex;
                        justify-content: flex-start;
                      ">
                      <div>
                        <!-- 升级成功的设备： -->
                        <div style="color: #16d09a">
                          {{ $t("device.upSuccessDevice") }}：
                        </div>
                        <div>
                          <span v-for="(item, index) in snUpOkList" :key="index" style="
                              margin-right: 5px;
                              max-height: 100px;
                              max-width: 200px;
                              overflow: hidden;
                              overflow-y: scroll;
                              display: flex;
                              flex-direction: column;
                            ">{{ `${item},` }}</span>
                        </div>
                      </div>
                      <div style="margin-left: 10px">
                        <!-- 升级失败的设备： -->
                        <div style="color: rgb(255, 62, 62)">
                          {{ $t("device.upFailDevice") }}：
                        </div>
                        <div>
                          <span v-for="(item, index) in snUpNoList" :key="index" style="
                              margin-right: 5px;
                              max-height: 100px;
                              max-width: 200px;
                              overflow: hidden;
                              overflow-y: scroll;
                              display: flex;
                              flex-direction: column;
                            ">{{ `${item},` }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- 固件名称(上面已存在) -->
                    <!-- <div class="progressName">
                      <i class="iconfont icon-fujian"></i>
                      {{firmwareName}}
                                </div> -->
                    <!-- <div class="progressCancel"></div> -->
                  </div>
                  <div class="progerssCompleteEquipment" v-show="progerssComplete && upgradeDeviceBatchSign != true">
                    <!-- <div class="progressName">
                      <i class="iconfont icon-fujian"></i>
                      {{ firmwareName }}
                    </div> -->
                    <div class="progressCancel"></div>
                  </div>
                </el-form-item>
              </el-form>
              <div style="text-align: right">
                <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
                <button style="margin-right: 20px" v-show="progressUp" class="btn btn-dark" @click="upgradeCancel">
                  {{ $t("firmware.upgrade_quit6") }}
                </button>
                <!-- 批量升级 -->
                <button v-if="upgradeDeviceBatchSign == true" class="btn btn-dark" @click="submitUpgradeDeviceBatch">
                  {{ $t("device.confirm") }}
                </button>
                <!-- 单个升级 -->
                <el-button v-else class="elbtn btn-dark" :disabled="upgradebButtonStatus"
                  @click="submitUpgradeDevice">{{
                    $t("device.confirm") }}</el-button>
              </div>
            </div>
            <div slot="footer">
              <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
              <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
            </div>
          </device-dialog>
          <!-- 透传固件升级 -->
          <!-- v-if="upgradeDeviceVisible" -->
          <!-- <device-dialog :class="{ 'showDialog': cloudUpgradeDeviceVisible, 'hideDialog': !cloudUpgradeDeviceVisible }"
            :title="$t('device.device_upgrade')" :visible.sync="cloudUpgradeDeviceVisible" width="580px" noFooter>
            <div slot="content">
              <el-form class="grid upload-container upgradeNew">
                <el-form-item :label="$t('device.upgradeType')" size="small">
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">{{ $t('device.defaultUpgrade') }}</el-radio>
                    <el-radio :label="2">{{ $t('device.cloudUpgrade') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div style="text-align:right;">
                <button class="btn btn-dark" @click="submitCloudUpgradeDevice">{{ $t('device.confirm') }}</button>
              </div>
            </div>
            <div slot="footer">
            </div>
          </device-dialog> -->
          <!-- 固件升级二次弹窗（增加固件的对话框） -->
          <!-- style="z-index:2014!important;" -->
          <!-- v-if="dialogAdd" -->
          <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
          <update-dialog :title="$t('firmware.Upload_firmware')" v-if="dialogAdd" :visible.sync="dialogAdd" width="40vw"
            noFooter style="z-index: 3000">
            <div slot="content">
              <el-form class="grid upload-container">
                <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
                <el-form-item :label="$t('firmware.Firmware_description')" size="small">
                  <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <div class="upload-contents">
                    <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                      <i class="iconfont icon-shangchuan1"></i>
                      <!-- {{$t('datalogger.Upload')}} -->
                    </button>
                    <div class="upload-tip">
                      {{
                        `${$t("datalogger.Upload")} (${$t("firmware.limit0")})`
                      }}
                    </div>
                    <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                      @change="uploadfile($event)" />
                  </div>
                </el-form-item>
              </el-form>
              <div style="text-align: right">
                <button class="btn btn-dark" @click="dialogAdd = false">
                  {{ $t("datalogger.confirm") }}
                </button>
                <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
              </div>
            </div>
            <div slot="footer">
              <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
              <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
            </div>
          </update-dialog>
          <!-- 升级结果提示(成功) -->
          <!-- v-if="upgradeDeviceSucVisible" -->
          <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceSucVisible" :class="{
            showDialog: upgradeDeviceSucVisible,
            hideDialog: !upgradeDeviceSucVisible,
          }" width="500px" noFooter>
            <div slot="content">
              <div class="showresultbox">
                <span class="showbase showsuccess"></span>
                <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
                <span class="showresulttext">{{ deviceTipMsg }}</span>
                <!-- 确定 -->
                <div class="showoperate">
                  <button class="btn btn-dark" @click="closeUpgradeSuccess()">
                    {{ $t("datalogger.confirm") }}
                  </button>
                </div>
              </div>
            </div>
          </device-dialog>
          <!-- 升级结果提示(失败) -->
          <!-- v-if="upgradeDeviceFailVisible" -->
          <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceFailVisible" :class="{
            showDialog: upgradeDeviceFailVisible,
            hideDialog: !upgradeDeviceFailVisible,
          }" width="500px" noFooter>
            <div slot="content">
              <div class="showresultbox">
                <span class="showbase showfail"></span>
                <span class="showresulttext">{{ deviceTipMsg }}</span>
                <!-- 确定 -->
                <div class="showoperate">
                  <button class="btn btn-dark" @click="closeUpgradeFail()">
                    {{ $t("datalogger.confirm") }}
                  </button>
                </div>
              </div>
            </div>
          </device-dialog>
          <!-- 导出报表 -->
          <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>
        </el-dialog>
        <!-- 逆变器调试 -->
        <!-- v-if="debugDeviceVisible" -->
        <device-dialog :title="$t('device.debug')" :visible.sync="debugDeviceVisible" :class="{
          showDialog: debugDeviceVisible,
          hideDialog: !debugDeviceVisible,
        }" noFooter>
          <div slot="content">
            <el-form class="grid">
              <el-form-item :label="$t('device.Device_pn')" size="small">
                <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('device.Instruction')" size="small">
                <el-input v-model="devDebug.cmd" :placeholder="$t('device.such_as')" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }" auto-complete="off"></el-input>
              </el-form-item>
              <!-- 发送指令 -->
              <el-form-item label=" ">
                <div style="text-align: right">
                  <button class="btn btn-dark" type="button" @click="submitDebugDevice()">
                    {{ $t("device.send") }}
                  </button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('device.return_content')" size="small">
                <!-- <el-input 
                  readonly 
                  v-model="debugReturn" 
                  type="textarea" 
                  auto-complete="off"
                            ></el-input> -->
                <div class="debug-return">
                  <!-- id="link" -->
                  <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
                  <div class="return-tool">
                    <span class="btn" style="margin-right: 15px" @click="fuzhi($event)" data-clipboard-action="copy"
                      data-clipboard-target="#link"><i class="ico ico-copy"></i>{{ $t("device.copy_val") }}
                    </span>
                    <span class="btn" @click="qingkong()"><i class="ico ico-clear"></i>{{ $t("device.clear_val") }}
                    </span>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer">
            <!-- <button 
              class="button-hollow" 
              @click="qingkong()"
                        >{{$t('device.clear_data')}}</button> -->
            <!-- <button
              class="button-solid"
              type="primary"
              @click="submitDebugDevice()"
                        >{{$t('device.send')}}</button> -->
          </div>
        </device-dialog>

        <!-- 控制项 -->
        <!-- v-if="controlDeviceVisible" -->
        <device-dialog :title="$t('device.control')" :width="'1000px'" style="padding: 0 35px 36px"
          :visible.sync="controlDeviceVisible" :class="{
            showDialog: controlDeviceVisible,
            hideDialog: !controlDeviceVisible,
          }" noFooter>
          <div @click="clickClosePicker()" class="control" slot="content">
            <div v-if="vcodeBox == '08'" style="width: 100%; text-align: right; padding-right: 40px">
              <el-button v-loading="oneClickReadFlag" style="
                  height: 30px;
                  color: #fff;
                  background-color: rgba(23, 194, 133, 0.5);
                " @click="oneClickRead()" class="submit-control btn btn-dark">
                {{ $t("device.one_click_read") }}
              </el-button>
            </div>
            <div v-if="tableDataBse.length">
              <div class="tableTitle">
                {{ $t("createPlant.basic_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataBse" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataStd.length">
              <div class="tableTitle">
                {{ $t("createPlant.Standard_setting") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataStd" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataSvs.length">
              <div class="tableTitle">
                {{ $t("createPlant.System_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataPvs.length">
              <div class="tableTitle">
                {{ $t("createPlant.Solar_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')" style="background-color: #fff">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataGrd.length">
              <div class="tableTitle">
                {{ $t("createPlant.Grid_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')" style="padding: 0">
                  <template slot-scope="scope">
                    <div style="padding: 0" class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="tableDataBat.length">
              <div class="tableTitle">
                {{ $t("createPlant.Battery_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataBat" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataCts.length">
              <div class="tableTitle">
                {{ $t("createPlant.Control_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataCts" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataLos.length">
              <div class="tableTitle">{{ $t("createPlant.Load_setting") }}</div>
              <el-table class="tableBackgruond" :data="tableDataLos" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataBas.length">
              <div class="tableTitle">
                {{ $t("createPlant.Basic_setting") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataBas" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataAdv.length">
              <div class="tableTitle">
                {{ $t("createPlant.Advanced_setting") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="tableDataElse.length">
              <div class="tableTitle">
                {{ $t("createPlant.other_settings") }}
              </div>
              <el-table class="tableBackgruond" :data="tableDataElse" stripe border :empty-text="$t('message.nodata')"
                :cell-style="OperationStyle">
                <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
                <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')" min-width="160px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                      popper-class="select-search-recharge">
                      <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                    <div @click.stop v-else-if="
                      scope.row.id === 'system_time' ||
                      scope.row.id === 'sys_system_time'
                    ">
                      <el-date-picker v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false" :append-to-body="false" type="datetime"
                        :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date"
                        :placeholder="'yyyy-MM-dd HH:mm:ss'">
                      </el-date-picker>
                    </div>
                    <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                      :placeholder="scope.row.hint"></el-input>
                    <el-input v-model="scope.row.controlvalue" v-else></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="200px" :label="$t('device.Operation')">
                  <template slot-scope="scope">
                    <div class="instructieClass">
                      <el-button v-loading="scope.row.isLoading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-shuaxin"></i>
                        <span>{{ $t("device.read") }}</span>
                      </el-button>
                      <el-button v-loading="scope.row.Loading" style="
                          color: #fff;
                          background-color: rgba(23, 194, 133, 0.5);
                        " @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                        <i class="iconfont icon-caozuo_tiaoshi"></i>
                        <span>{{ $t("device.distribute") }}</span>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 无数据 -->
            <div v-if="noDataControl">
              <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
                <el-table-column :label="$t('device.Field_Name')"></el-table-column>
                <el-table-column :label="$t('device.Unit')"></el-table-column>
                <el-table-column :label="$t('device.set')"></el-table-column>
                <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
              </el-table>
            </div>
          </div>
        </device-dialog>

        <!-- 固件升级 -->
        <!-- v-if="upgradeDeviceVisible" -->
        <device-dialog :class="{
          showDialog: upgradeDeviceVisible,
          hideDialog: !upgradeDeviceVisible,
        }" :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible" width="580px" noFooter>
          <div slot="content">
            <el-form class="grid upload-container upgradeNew" element-loading-spinner="el-icon-loading"
              v-loading="loadingupgradeDev">
              <!-- 批量升级提示(注意国际化) -->
              <el-form-item label=" ">
                <!-- 注意：批量升级是给多个设备升级同一个设备固件，如不清楚设备所适合的固件，请谨慎选择！ -->
                <span v-if="upgradeDeviceBatchSign == true" style="color: rgba(255, 62, 62, 1); font-size: 14px">{{
                  $t("device.upBatchDeviceTip") }}</span>
              </el-form-item>
              <el-form-item :label="$t('device.select_firmware')" size="small">
                <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
                  :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                  <template slot="empty">
                    <div style="text-align: right">
                      <!-- <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button> -->
                      <button class="upFirewareBtn" @click="uploadFirmwareAdd()">
                        {{ $t("firmware.Upload_firmware") }}
                      </button>
                    </div>
                  </template>
                  <div style="text-align: right">
                    <!-- <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button> -->
                    <button class="upFirewareBtn" @click="uploadFirmwareAdd()">
                      {{ $t("firmware.Upload_firmware") }}
                    </button>
                  </div>
                  <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('device.firmware_type')" size="small">
                <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype"
                  :placeholder="$t('device.select_type')" popper-class="select-search-recharge">
                  <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('device.upgrade_brate')" size="small">
                <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label=" ">
                <!-- 原上传按钮 -->
                <!-- <div class="upload-contents">
                  <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                    <i class="iconfont icon-shangchuan"></i>
                    {{$t('device.Upload')}}
                  </button>
                  <div class="upload-tip">{{$t('firmware.limit')}}</div>
                            </div> -->
                <div class="progressShowEquipment">
                  <div class="processstatueEquipment" v-show="progressUp">
                    {{ $t("firmware.upgrading") }}
                  </div>
                  <div :class="progressFlag == 0
                    ? 'processstatueEquipment'
                    : 'processstatueEquipment1'
                    " v-show="progerssComplete">
                    {{ resultTitle }}
                  </div>
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{ firmwareName }}
                  </div>
                  <div class="progressCancel" @click="upgradeCancel">
                    <i class="iconfont icon-delete"></i>
                  </div> -->
                </div>
                <div class="processDataEquipment" v-show="progressUp">
                  <el-progress :format="progressText" :percentage="progress" :stroke-width="10"
                    color="#33FFB6"></el-progress>
                  <!-- <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div> -->
                </div>
                <!-- 原上传按钮 -->
                <!-- <input
                  type="file"
                  class="upload-input"
                  ref="fileUploader"
                  accept="application/octet-stream"
                  @change="uploadfile($event)"
                            /> -->
                <!-- 暂时注释显隐条件 -->
                <!-- v-show="progerssComplete" -->
                <div class="progerssCompleteEquipment" v-show="upgradeDeviceBatchSign == true">
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{ firmwareName }}
                  </div> -->
                  <!-- <div class="progressCancel"></div> -->
                  <!-- 增：已完成升级的设备SN(注意国际化) -->
                  <div style="
                      margin-bottom: 10px;
                      display: flex;
                      justify-content: flex-start;
                    ">
                    <div>
                      <!-- 升级成功的设备： -->
                      <div style="color: #16d09a">
                        {{ $t("device.upSuccessDevice") }}：
                      </div>
                      <div>
                        <span v-for="(item, index) in snUpOkList" :key="index" style="
                            margin-right: 5px;
                            max-height: 100px;
                            max-width: 200px;
                            overflow: hidden;
                            overflow-y: scroll;
                            display: flex;
                            flex-direction: column;
                          ">{{ `${item},` }}</span>
                      </div>
                    </div>
                    <div style="margin-left: 10px">
                      <!-- 升级失败的设备： -->
                      <div style="color: rgb(255, 62, 62)">
                        {{ $t("device.upFailDevice") }}：
                      </div>
                      <div>
                        <span v-for="(item, index) in snUpNoList" :key="index" style="
                            margin-right: 5px;
                            max-height: 100px;
                            max-width: 200px;
                            overflow: hidden;
                            overflow-y: scroll;
                            display: flex;
                            flex-direction: column;
                          ">{{ `${item},` }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 固件名称(上面已存在) -->
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{firmwareName}}
                              </div> -->
                  <!-- <div class="progressCancel"></div> -->
                </div>
                <div class="progerssCompleteEquipment" v-show="progerssComplete && upgradeDeviceBatchSign != true">
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{ firmwareName }}
                  </div> -->
                  <div class="progressCancel"></div>
                </div>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
              <button style="margin-right: 20px" v-show="progressUp" class="btn btn-dark" @click="upgradeCancel">
                {{ $t("firmware.upgrade_quit6") }}
              </button>
              <!-- 批量升级 -->
              <button v-if="upgradeDeviceBatchSign == true" class="btn btn-dark" @click="submitUpgradeDeviceBatch">
                {{ $t("device.confirm") }}
              </button>
              <!-- 单个升级 -->
              <el-button v-else class="elbtn btn-dark" :disabled="upgradebButtonStatus" @click="submitUpgradeDevice">{{
                $t("device.confirm") }}</el-button>
            </div>
          </div>
          <div slot="footer">
            <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
            <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
          </div>
        </device-dialog>
        <!-- 透传固件升级 -->
        <!-- v-if="upgradeDeviceVisible" -->
        <!-- <device-dialog :class="{ 'showDialog': cloudUpgradeDeviceVisible, 'hideDialog': !cloudUpgradeDeviceVisible }"
          :title="$t('device.device_upgrade')" :visible.sync="cloudUpgradeDeviceVisible" width="580px" noFooter>
          <div slot="content">
            <el-form class="grid upload-container upgradeNew">
              <el-form-item :label="$t('device.upgradeType')" size="small">
                <el-radio-group v-model="radio">
                  <el-radio :label="1">{{ $t('device.defaultUpgrade') }}</el-radio>
                  <el-radio :label="2">{{ $t('device.cloudUpgrade') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button class="btn btn-dark" @click="submitCloudUpgradeDevice">{{ $t('device.confirm') }}</button>
            </div>
          </div>
          <div slot="footer">
          </div>
        </device-dialog> -->
        <!-- 固件升级二次弹窗（增加固件的对话框） -->
        <!-- style="z-index:2014!important;" -->
        <!-- v-if="dialogAdd" -->
        <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
        <update-dialog :title="$t('firmware.Upload_firmware')" v-if="dialogAdd" :visible.sync="dialogAdd" width="40vw"
          noFooter style="z-index: 3000">
          <div slot="content">
            <el-form class="grid upload-container">
              <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
              <el-form-item :label="$t('firmware.Firmware_description')" size="small">
                <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('browse.desc')" size="small">
                <el-input v-model="remark" :placeholder="$t('firmware.enter_content')"></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <div class="upload-contents">
                  <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                    <i class="iconfont icon-shangchuan1"></i>
                    <!-- {{$t('datalogger.Upload')}} -->
                  </button>
                  <div class="upload-tip">
                    {{
                      `${$t("datalogger.Upload")} (${$t("firmware.limit0")})`
                    }}
                  </div>
                  <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                    @change="uploadfile($event)" />
                </div>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <button class="btn btn-dark" @click="dialogAdd = false">
                {{ $t("datalogger.confirm") }}
              </button>
              <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
            </div>
          </div>
          <div slot="footer">
            <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
            <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
          </div>
        </update-dialog>
        <!-- 升级结果提示(成功) -->
        <!-- v-if="upgradeDeviceSucVisible" -->
        <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceSucVisible" :class="{
          showDialog: upgradeDeviceSucVisible,
          hideDialog: !upgradeDeviceSucVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="closeUpgradeSuccess()">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 升级结果提示(失败) -->
        <!-- v-if="upgradeDeviceFailVisible" -->
        <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceFailVisible" :class="{
          showDialog: upgradeDeviceFailVisible,
          hideDialog: !upgradeDeviceFailVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="closeUpgradeFail()">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
        <!-- v-if="deletingDeviceInfo" -->
        <device-dialog :title="$t('device.deleteDevice')" :visible.sync="deletingDeviceInfo" :class="{
          showDialog: deletingDeviceInfo,
          hideDialog: !deletingDeviceInfo,
        }" width="30vw" noFooter>
          <div class="content_tishi" slot="content">
            <div class="tital">
              <!-- <i class="iconfont icon-gantanhao"></i> -->
              <span class="contentdelete" style="width: 100%; text-align: left">{{ $t("device.confirm_deldte") }}</span>
            </div>
            <div class="disabledescr">
              <span style="width: 100%; text-align: left; margin-top: 28px">{{
                $t("account.notRecovered")
              }}</span>
            </div>
            <!-- </div> -->
            <div class="deletfotter" style="text-align: right; margin-top: 28px">
              <button class="btn btn-dark" style="margin-right: 10px" @click="submitDeleteDevice">
                {{ $t("device.confirm") }}
              </button>
              <button class="btn btn-light" @click="deletingDeviceInfo = null">
                {{ $t("device.cancel") }}
              </button>
            </div>
          </div>
        </device-dialog>
        <!-- 删除结果提示(成功) -->
        <!-- v-if="delDeviceSucVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceSucVisible" :class="{
          showDialog: delDeviceSucVisible,
          hideDialog: !delDeviceSucVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t("project.delSuc") }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delDeviceSucVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 删除结果提示(失败) -->
        <!-- v-if="delDeviceFailVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceFailVisible" :class="{
          showDialog: delDeviceFailVisible,
          hideDialog: !delDeviceFailVisible,
        }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delDeviceFailVisible = false">
                  {{ $t("datalogger.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!--编辑设备控制权限弹框 -->
        <device-dialog :visible.sync="editDeviceControlVisible" :title="$t('device.edit_control')"
          v-if="editDeviceControlVisible" :class="{
            showDialog: editDeviceControlVisible,
            hideDialog: !editDeviceControlVisible,
          }" width="1125px" noFooter>
          <!-- <div slot="content">
            <div class="editControl">
              <div class="searchprotocol">
                <div class="searchName">{{$t('device.Equipment_agreement')}} :</div>
                <el-select
                  v-model="searchProtocol"
                  :placeholder="$t('device.Equipment_agreement')"
                  popper-class="select-search-recharge"
                  @change="getProtocolData"
                >
                  <el-option
                    v-for="item in protocolAllData"
                    :key="item.desc"
                    :value="item.devcode"
                    :label="item.desc"
                  ></el-option>
                </el-select>
              </div>
              <div class="personProtocol">
                <div class="contentLeft">{{$t('device.person_cansee')}}</div>
                <div class="contentRight">
                  <div class="top">
                    <el-checkbox
                      v-model="CheckAllPerson"
                      @change="checkAllPerson"
                    >{{$t('device.Check_all')}}</el-checkbox>
                    <el-checkbox
                      v-model="CheckNoPerson"
                      @change="checkNoPerson"
                    >{{$t('device.Cancel_all')}}</el-checkbox>
                  </div>
                  <div class="protoclContents" v-if="protocolDataShow">
                    <el-checkbox-group v-model="checkPersonData">
                      <el-checkbox
                        v-for="item in checkStatueData"
                        :label="item.name"
                        :title="item.name"
                        :key="item.id"
                        class="checkboxUnit"
                        @change="protoclPersonChange(item)"
                      >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="noData" v-else>{{$t('message.nodata')}}</div>
                </div>
              </div>
              <div class="adminProtocol">
                <div class="contentLeft">{{$t('device.administrator_cansee')}}</div>
                <div class="contentRight">
                  <div class="top">
                    <el-checkbox
                      v-model="CheckAllAdmin"
                      @change="checkAllAdmin"
                    >{{$t('device.Check_all')}}</el-checkbox>
                    <el-checkbox
                      v-model="CheckNoAdmin"
                      @change="checkNoAdmin"
                    >{{$t('device.Cancel_all')}}</el-checkbox>
                  </div>
                  <div class="protoclContents" v-if="protocolDataShow">
                    <el-checkbox-group v-model="checkAdminData">
                      <el-checkbox
                        v-for="item in checkStatueData"
                        :label="item.name"
                        :title="item.name"
                        :key="item.id"
                        class="checkboxUnit"
                        @change="protoclAdminChange(item)"
                      >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="noData" v-else>{{$t('message.nodata')}}</div>
                </div>
              </div>
            </div>
                      </div> -->
          <div slot="content">
            <div class="editControl">
              <div class="searchprotocol">
                <!-- 设备权限 -->
                <div class="searchName">
                  {{ `${$t("device.Equipment_agreement")}：` }}
                </div>
                <el-select filterable v-model="searchProtocol" :placeholder="$t('device.Equipment_agreement')"
                  popper-class="select-search-recharge" @change="getProtocolData">
                  <el-option v-for="item in protocolAllData" :key="item.desc" :value="item.devcode"
                    :label="item.desc"></el-option>
                </el-select>
              </div>
              <div class="personProtocol">
                <!-- 业主权限 -->
                <div class="contentLeft">
                  <div class="top">
                    <div class="protocolTitle">
                      {{ `${$t("device.person_authority")}：` }}
                    </div>
                    <el-checkbox v-model="CheckAllPerson" :disabled="!protocolDataShow" @change="checkAllPerson">{{
                      $t("device.Check_all") }}</el-checkbox>
                    <el-checkbox v-model="CheckNoPerson" :disabled="!protocolDataShow" @change="checkNoPerson">{{
                      $t("device.Cancel_all") }}</el-checkbox>
                  </div>
                </div>
                <div class="contentRight">
                  <div class="protoclContents" v-if="protocolDataShow">
                    <el-checkbox-group v-model="checkPersonData">
                      <el-checkbox v-for="item in checkStatueData" :label="item.name" :title="item.name" :key="item.id"
                        class="checkboxUnit" @change="protoclPersonChange(item)">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="noData" v-else>{{ $t("message.nodata") }}</div>
                </div>
              </div>
              <div class="adminProtocol">
                <!-- 管理员权限 -->
                <div class="contentLeft">
                  <div class="top">
                    <div class="protocolTitle">
                      {{ `${$t("device.admin_authority")}：` }}
                    </div>
                    <el-checkbox v-model="CheckAllAdmin" :disabled="!protocolDataShow" @change="checkAllAdmin">{{
                      $t("device.Check_all") }}</el-checkbox>
                    <el-checkbox v-model="CheckNoAdmin" :disabled="!protocolDataShow" @change="checkNoAdmin">{{
                      $t("device.Cancel_all") }}</el-checkbox>
                  </div>
                </div>
                <div class="contentRight">
                  <div class="protoclContents" v-if="protocolDataShow">
                    <el-checkbox-group v-model="checkAdminData">
                      <el-checkbox v-for="item in checkStatueData" :label="item.name" :title="item.name" :key="item.id"
                        class="checkboxUnit" @change="protoclAdminChange(item)">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="noData" v-else>{{ $t("message.nodata") }}</div>
                </div>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 批量查询升级进度 -->
        <device-dialog :class="{
          showDialog: queryUpgradeDeviceVisible,
          hideDialog: !queryUpgradeDeviceVisible,
        }" :visible.sync="queryUpgradeDeviceVisible" :title="$t('device.queryUpgrade')"
          v-if="queryUpgradeDeviceVisible" width="1125px" noFooter>
          <div slot="content">
            <div class="upgardeControl">
              <el-table style="color: #fff; font-weight: 400" border :empty-text="$t('account.nodata')"
                :data="selectedDevice1" :header-cell-style="{
                  background: 'rgb(65, 80, 90)',
                  color: '#ffffff',
                }">
                <el-table-column prop="pn" :label="$t('device.device_pn')" width="180">
                </el-table-column>
                <el-table-column prop="sn" :label="$t('device.device_sn')" width="180">
                </el-table-column>
                <el-table-column prop="devcode" :label="$t('device.Equipment_agreement')">
                </el-table-column>
                <el-table-column prop="devaddr" :label="$t('device.device_address')" width="180">
                </el-table-column>
                <el-table-column prop="upgradeStatus" :label="$t('device.device_upgradeStatus')" width="180">
                  <template slot-scope="scope">
                    <div v-if="scope.row.upgradeStatus == 5">
                      {{ $t("firmware.upgrade_quit5") }}
                    </div>
                    <div v-else-if="scope.row.upgradeStatus == 4">
                      {{ $t("firmware.upgrade_quit6") }}
                    </div>
                    <div v-else-if="scope.row.upgradeStatus == 3" style="color: #30ec70">
                      {{ $t("firmware.upgrade_quit3") }}
                    </div>
                    <div v-else-if="scope.row.upgradeStatus == 2" style="color: #ff3e3e">
                      {{ $t("firmware.upgrade_quit7") }}
                    </div>
                    <div v-else-if="scope.row.upgradeStatus == 1" style="color: #ec9630">
                      {{ $t("firmware.upgrade_quit8") }}
                    </div>
                    <div v-else-if="scope.row.upgradeStatus == 0">
                      {{ $t("firmware.upgrading") }}
                    </div>
                    <div v-else>{{ $t("errCode.12") }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="progress" :label="$t('device.device_upgradeProgress')">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </device-dialog>
      </div>
    </div>
    <!-- 日月元透传升级 -->
    <!-- <div class="upgradeInfo" v-if="$store.state.device.isShow == 2">
      <div class="deviceHeader">
        <div class="deviceHeaderLeft">
          <div class="closepage" @click="goDeviceList"></div>
          <div>{{ `${$t('device.deviceList')}` }}</div>
        </div>
        <div class="deviceHeaderRight">
          <button @click="cloudsUpgradeDevice" style="border-right: 1px solid #000;"  class="button-solid button buttonDeviceJurisdiction">
            {{ `${$t('device.addUpgrade')}` }}
            <span class="iconfont icon-caozuo_shengji"></span>
          </button>
          <button @click="continueCloudsUpgradeDevice"  class="button-solid button buttonDeviceJurisdiction">
            {{ `${$t('device.continueUpgrade')}` }}
            <span class="iconfont icon-caozuo_shengji"></span>
          </button>
        </div>
      </div>
      <div class="deviceBody">
        <div class="title ggTitle1">{{ `${$t('device.deviceInfo')}` }}</div>
        <div class="cell name light ggCell11 splitHLine">{{ $t('device.datalogger_pn') }}</div>
        <div class="cell data dark ggCell12 splitHLine">{{ upgradeData.pn }}</div>
        <div class="ggCell01 splitVBox"></div>
        <div class="cell name light ggCell13 splitHLine">{{ $t('alarm.Device_SN') }}</div>
        <div class="cell data dark ggCell14 splitHLine">{{ upgradeData.sn }}</div>
        <div class="title ggTitle2">{{ `${$t('device.deviceUpgradeProgress')}` }}</div>
        <div class="cell name light ggCell21 splitHLine">{{ $t('device.device_upgradeName') }}</div>
        <div v-if="this.cloudsUpgradeName" class="cell data dark ggCell22 splitHLine">{{ cloudsUpgradeName }}</div>
        <div v-else class="cell data dark ggCell22 splitHLine">{{ $t('account.nodata') }}</div>
        <div class="ggCell02 splitVBox"></div>
        <div class="cell name light ggCell23 splitHLine">{{ $t('device.upgradeProgress') }}</div>
        <div v-if="this.cloudsUpgradeData.status==0" class="cell data dark ggCell24 splitHLine">{{ cloudsUpgradeData.progress/10+'%' }}</div>
        <div v-else class="cell data dark ggCell24 splitHLine">{{  $t('account.nodata') }}</div>
        <device-dialog :class="{ 'showDialog': cloudsUpgradeDeviceVisible, 'hideDialog': !cloudsUpgradeDeviceVisible }"
          :title="$t('device.device_cloudsUpgrade')" :visible.sync="cloudsUpgradeDeviceVisible" width="680px" noFooter>
          <div slot="content">
            <el-form :model="searchclouds" :rules="firmwareRules" ref="createFirmwareUpgrade"  class="grid upload-container upgradeNew">
              <el-form-item prop="firmwareId" :label="$t('device.select_firmware')" size="small">
                <el-select v-model="searchclouds.firmwareId"
                  :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                  <el-option v-for="item in firmwaresData" :key="item.firmwareName" :label="item.firmwareName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="firmwareType" :label="$t('device.firmware_type')" size="small">
                <el-select v-model="searchclouds.firmwareType" :placeholder="$t('device.select_type')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in cloudsfirmwaretypelist" :key="item.id" :label="item.typeName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="baudrate" :label="$t('device.upgrade_brate')" size="small">
                <el-select v-model="searchclouds.baudrate" :placeholder="$t('device.select_brate')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button :disabled=submitCloudsUpgradeDeviceDisabled class="btn btn-dark" @click="submitCloudsUpgradeDevice">{{ $t('device.confirm') }}</button>
            </div>
          </div>
          <div slot="footer">
          </div>
        </device-dialog>
        <device-dialog :class="{ 'showDialog': continueCloudUpgradeDeviceVisible, 'hideDialog': !continueCloudUpgradeDeviceVisible }"
          :title="$t('device.device_continueUpgrade')" :visible.sync="continueCloudUpgradeDeviceVisible" width="680px" noFooter>
          <div slot="content">
            <el-form :model="searchclouds" :rules="firmwareRules" ref="continueFirmwareUpgrade" class="grid upload-container upgradeNew">
              <el-form-item prop="step" :label="$t('device.step')" size="small">
                <el-input :placeholder="$t('device.firmware_step_message')" v-model="searchclouds.step" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item prop="firmwareId" :label="$t('device.select_firmware')" size="small">
                <el-select v-model="searchclouds.firmwareId"
                  :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                  <el-option v-for="item in firmwaresData" :key="item.id" :label="item.firmwareName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="firmwareType" :label="$t('device.firmware_type')" size="small">
                <el-select v-model="searchclouds.firmwareType" :placeholder="$t('device.select_type')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in cloudsfirmwaretypelist" :key="item.id" :label="item.typeName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="baudrate" :label="$t('device.upgrade_brate')" size="small">
                <el-select v-model="searchclouds.baudrate" :placeholder="$t('device.select_brate')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button :disabled=submitCloudsUpgradeDeviceDisabled class="btn btn-dark" @click="submitContinueCloudsUpgradeDevice">{{ $t('device.confirm') }}</button>
            </div>
          </div>
          <div slot="footer">
          </div>
        </device-dialog>
      </div>
    </div> -->
    <div v-if="$store.state.device.isShow == 3" class="debugInfo">
      <div class="deviceHeader">
        <div class="deviceHeaderLeft">
          <div class="closepage" @click="goList"></div>
          <div>{{ `${$t("device.deviceDebug")}` }}</div>
        </div>
      </div>
      <div class="deviceBody">
        <el-form class="grid">
          <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
            <div>{{ deviceInfo.pn }}</div>
          </el-form-item>
          <el-form-item :label="$t('datalogger.communication_address')" size="small">
            <el-input :disabled="true" class="devaddrClass" type="number" v-model="deviceInfo.devaddr"
              auto-complete="off" oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
          </el-form-item>
          <el-form-item :label="$t('datalogger.Instruction')" size="small">
            <el-input :rows="4" v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div style="text-align: right">
              <button type="button" class="btn btn-dark" @click="submitDebugDevice()">
                {{ $t("datalogger.send") }}
              </button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('datalogger.return_content')" size="small">
            <div class="debug-return">
              <div class="return-tool">
                <span class="btn" style="margin-right: 15px" @click="fuzhi($event)" data-clipboard-action="copy"
                  data-clipboard-target="#link">
                  <i class="ico ico-copy"></i>
                  {{ $t("device.copy_val") }}
                </span>
                <span class="btn" @click="qingkong()">
                  <i class="ico ico-clear"></i>
                  {{ $t("device.clear_val") }}
                </span>
              </div>
              <el-input :rows="10" readonly id="link" v-model="debugReturn" type="textarea"
                auto-complete="off"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import deviceDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
import exportPlantDialog from "@/components/dialognew/exportPlant";
// import config from '@/assets/js/config';
import clipboard from "@/assets/js/clipboard";
import encryption from "@/assets/js/encryption";
import { i18n } from "@/i18n";
import { mapGetters , mapState} from "vuex";

import Vue from "vue";
export default {
  components: {
    deviceDialog,
    updateDialog,
    exportPlantDialog,
  },
  data() {
    var validatepwd = (rule, value, callback) => {
      console.log(value, callback, "33333333");

      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.pwdtip = this.$t("message.pwd_is_required");
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.pwdtip = this.$t("signup.pwdformat");
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //重置密码的密码确认
    var validateconfNewpwd = (rule, value, callback) => {
      // console.log(value, callback, "222222222222222");
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.resetform.newpwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    return {
      resetRules: {
        usr: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur",
          },
        ],
        newpwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        // 确认密码
        confPwd: [
          { required: true, validator: validateconfNewpwd, trigger: "change" },
        ],
      },
      //重置密码
      resetform: {
        usr: "",
        newpwd: "",
        confPwd: "",
      },
      count: "",
      controlDevcode: "",
      upgradebButtonStatus: false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")
        ? JSON.parse(sessionStorage.getItem("buttonArr"))
        : [],
      // submitCloudsUpgradeDeviceDisabled:false,
      // inTime:null,
      // upgradeFlag:true,
      // upgradeData:{},
      // cloudsUpgradeData:{},
      // cloudsUpgradeName:"",
      // cloudsUpgradeStatus:"",
      loadingupgradeDev: false,
      hideFlag: false, //德业域名显隐
      noDataControl: false,
      emptyText: false,
      protocolIdBox: null, //控制项全部ID
      protocolNameBox: null, //控制项全部名称
      vcodeBox: "", //厂家编号的盒子
      CheckAllPerson: false,
      CheckAllAdmin: false,
      CheckNoPerson: false,
      CheckNoAdmin: false,
      checkAdminData: null,
      checkPersonData: null,
      checkStatueData: null,
      protocolDataShow: true,
      protocolAllData: null,
      searchProtocol: "",
      statueNum: {
        normal: "100",
        offline: "100",
        warning: "100",
        fault: "100",
        standby: "100",
      },
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        usr: "",
        brand: "",
        // pn: "A0019510470371",
        pn: "",
        search: "",
      },
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0",
      },
      // 设备状态表
      deviceStatus: {
        0: {
          label: i18n.t('statistic.normal'),
          class: 'status-normal',
          name: 'normal',
        },
        1: {
          label: i18n.t('statistic.offline'),
          class: 'status-offline',
          name: 'offline',
        },
        4: {
          label: i18n.t('statistic.warning'),
          class: 'status-warning',
          name: 'warning',
        }
      },
      // 设备状态表新版
      deviceStatusNew: {
        total: {
          num: 0,
          label: this.$t("statistic.All"),
          class: "status-total",
          ico: "icon-a-mingchengnibianqi",
          color: "color-total",
        },
        normalCount: {
          num: 0,
          label: this.$t("statistic.normal"),
          class: "status-normal",
          ico: "icon-a-mingchengnibianqi",
          color: "color-normal",
        },
        standby: {
          num: 0,
          label: this.$t("statistic.standby"),
          class: "status-standby",
          ico: "icon-a-mingchengnibianqi",
          color: "color-standby",
        },
        warningCount: {
          num: 0,
          label: this.$t("statistic.warning"),
          class: "status-warning",
          ico: "icon-a-mingchengnibianqi",
          color: "color-warning",
        },
        faultCount: {
          num: 0,
          label: this.$t("statistic.fault"),
          class: "status-fault",
          ico: "icon-a-mingchengnibianqi",
          color: "color-fault",
        },
        offCount: {
          num: 0,
          label: this.$t("statistic.offline"),
          class: "status-offline",
          ico: "icon-a-mingchengnibianqi",
          color: "color-offline",
        },
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0",
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1",
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2",
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3",
        },
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0",
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1",
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2",
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3",
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4",
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5",
        },
      ],
      firmwaretypelistUPG: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "1",
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "2",
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "3",
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "4",
        },
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0",
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400",
        },
        {
          label: 4800,
          value: "4800",
        },
        {
          label: 9600,
          value: "9600",
        },
        {
          label: 19200,
          value: "19200",
        },
        {
          label: 38400,
          value: "38400",
        },
        {
          label: 57600,
          value: "57600",
        },
        {
          label: 115200,
          value: "115200",
        },
      ],
      loadingDevice: false,
      // isLoading: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15,
      }, // 分页数据
      deviceList: [],
      tableDataBse: [],
      tableDataStd: [],
      tableDataSvs: [],
      tableDataPvs: [],
      tableDataGrd: [],
      tableDataBat: [],
      tableDataCts: [],
      tableDataLos: [],
      tableDataBas: [],
      tableDataAdv: [],
      tableDataElse: [],
      controlinter: [],
      controlvalue: "",
      editDeviceVisible: false,
      moreEditDeviceVisible: false,
      moreOwnerShipVisible: false,
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      oneClickReadFlag: false,
      oneClickReadTip: false,
      moreUpgradeDeviceVisible: false,
      isError: false,
      confpwdError: false,
      passpwdError: false,
      confpwdtip: "",
      usrtip: "",
      pwdtip: "",
      strength: false,
      // 打开重置密码弹框
      showResetpwdDialog: false,
      // 重置密码成功提示弹窗
      resetPwdSucVisible: false,
      // 重置密码失败提示弹窗
      resetPwdFailVisible: false,
      // 重置数采器
      resetDataloggerPn: "",
      resetDataloggerCode: "",
      // 重启数采器
      rebootDataloggerData: {
        pn: "",
        status: "",
      },
      //数采器名称
      dialogAlias: "",
      dataloggerTipMsg: "",
      // moreDeviceVisible: false,
      moreDeviceVisible: false,
      moreDeviceInfo: {
        pn: "",
        deviceSn: "",
        sn: "",
        usr: "",
      },
      // 解绑数采器弹框
      unbindDataloggerVisible: false,
      // 解绑数采器成功
      dataloggerUnbindSucVisible: false,
      // 解绑数采器失败
      dataloggerUnbindFailVisible: false,
      // cloudUpgradeDeviceVisible: false,
      // radio:1,
      // continueCloudUpgradeDeviceVisible: false,
      // // 云端升级弹窗
      // cloudsUpgradeDeviceVisible: false,
      // // 云端固件包数据
      // firmwaresData:[],
      // // 云端固件类型
      // cloudsfirmwaretypelist:[],
      // // 云端升级
      // searchclouds: {
      //   firmwareId: "",
      //   firmwareType: "",
      //   baudrate: "0",
      //   step:'',
      // },
      // 固件升级-校验规则
      firmwareRules: {
        step: [
          {
            required: true,
            message: this.$t("device.firmware_step_message"),
          },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: this.$t("device.numberRlues"),
            trigger: "blur",
          },
        ],
        firmwareId: [
          {
            required: true,
            message: this.$t("device.firmware_package_message"),
            trigger: ["blur", "change"],
          },
        ],
        firmwareType: [
          {
            required: true,
            message: this.$t("device.firmware_type_message"),
            trigger: ["blur", "change"],
          },
        ],
        baudrate: [
          {
            required: true,
            message: this.$t("device.baudrate_message"),
            trigger: ["blur", "change"],
          },
        ],
      },
      queryUpgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deleteDeviceVisible: false,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      moreControlDeviceVisible: false,
      editDeviceControlVisible: false, //控制权限弹框
      formEdit: {
        sn: "",
        deviceSn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        alias: "",
      },
      formOwnerShip: {
        pn: "",
        sn: "",
        deviceSn: "",
        usr: "",
        uid: "",
        oldUid: "",
        newUid: "",
      },
      newOwnerName: "",
      newOwnerUid: "",
      device: {
        pn: "",
      },
      devDebug: {
        cmd: "",
      },
      debugReturn: "",
      // 搜索弹出
      showSearch: false,
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      remark: "",//备注
      // 修改设备成功提示
      editDeviceSucVisible: false,
      // 修改设备失败提示
      editDeviceFailVisible: false,
      // 删除设备成功提示
      delDeviceSucVisible: false,
      // 删除设备失败提示
      delDeviceFailVisible: false,
      // 升级设备成功提示
      upgradeDeviceSucVisible: false,
      // 升级设备失败提示
      upgradeDeviceFailVisible: false,
      // 操作返回提示
      deviceTipMsg: "",
      // 批量操作勾选
      selectedDevice: [],
      selectedDevice1: [],
      // 导出报表
      exportPlantParams: [],
      // 导出报表按钮
      currentData: true,
      // 批量升级设备标记
      upgradeDeviceBatchSign: false,
      // 升级成功的设备列表
      snUpOkList: [],
      // 升级失败的设备列表
      snUpNoList: [],
      // 标记进行批量中的下一个是否进行
      allowNextUpgrade: true,
      intelligenceUpgradeVisible: false,
      intelligenceUpgradeInfo: {
        firmwareId:'',
        firmwareName:'',
        needConfirm:false,
        confirmMessage:'',
        qlfuResponse:'',
      },
      flag: false,
      resultTitle: "",
      progressFlag: Number,
      ownerPage: 0,
      ownerSelectList: [],
      ownerLoading: false,
      hasMoreOwner: true,
      ownerSearchKeyword: "",
    };
  },
  computed: {
    ...mapGetters({
      plantidCur: "getPlantidCur",
      curIsFollow: "getCurIsFollow",
      deviceInfo: "getDeviceInfo",
      upgradeUPG: "getUpgradeUPG",
      UpgradeTypeUPG: "getUpgradeTypeUPG",
    }),
             ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    // 日月元透传升级
    // 升级进度状态
    // cloudsUpgradeStatus(oval,nval){
    //   if (this.cloudsUpgradeStatus==0) {
    //     if (this.cloudsUpgradeData.progress!=1000) {
    //       this.inTime=setInterval(()=>{
    //         let params={
    //           key:this.cloudsUpgradeData.key,
    //           pn:this.upgradeData.pn,
    //         }
    //         this.$request.getUPG('/upg/api/auth/web/device/upgradeProgressByKey',params).then(res=>{
    //           if (res.code==0) {
    //             this.cloudsUpgradeData.progress=res.data.progress
    //             this.cloudsUpgradeStatus=res.data.status
    //           }
    //         })
    //       },3000)
    //     }else{
    //       clearInterval(this.inTime)
    //       this.inTime=null
    //     }
    //   }else{
    //     clearInterval(this.inTime)
    //     this.inTime=null
    //   }
    // },
    // 监听控制项弹框，触发其中的日期时间选择器弹框关闭
    controlDeviceVisible(val) {
      if (!val) {
        this.clickClosePicker();
        // const allArrays = [
        //   this.tableDataBse,
        //   this.tableDataStd,
        //   this.tableDataSvs,
        //   this.tableDataPvs,
        //   this.tableDataGrd,
        //   this.tableDataBat,
        //   this.tableDataCts,
        //   this.tableDataLos,
        //   this.tableDataBas,
        //   this.tableDataAdv,
        //   this.tableDataElse,
        // ]
        // sessionStorage.setItem(this.controlDevcode, JSON.stringify(allArrays));
      } else {
        // if (sessionStorage.getItem(this.controlDevcode, JSON.stringify(allArrays))==defind) {
        // }else{
        //   let aaa=sessionStorage.getItem(this.controlDevcode, JSON.stringify(allArrays))
        //   console.log(aaa,'aaa################');
        // }
      }
    },
    moreControlDeviceVisible(val) {
      if (!val) {
        this.clickClosePicker();
      }
    },
    deleteDeviceVisible(val) {
      if (!val) this.deletingDeviceInfo = null;
    },
    intelligenceUpgradeVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    upgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    moreUpgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    queryUpgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    },
    // 响应更新电站列表事件
    "$store.state.event.updateDeviceList"(val) {
      if (val) {
        this.getDeviceList(true);
        this.$store.state.event.updateDeviceList = false;
      }
    },
    // 监测当前项目ID更新设备列表
    plantidCur: {
      handler(val) {
        // console.log('watch-plantidCur', val.plantidCur);
        if (val.plantidCur != undefined) {
          this.getDeviceList();
          this.queryDeviceStatus();
        }
      },
      deep: true,
    },
    // 监测当前是否关注更新设备列表
    curIsFollow: {
      handler(val) {
        // console.log('watch-curIsFollow', val.curIsFollow);
        if (val.curIsFollow != undefined) {
          this.getDeviceList();
          this.queryDeviceStatus();
        }
      },
      deep: true,
    },
  },
  // 日月元透传升级
  // beforeDestroy(){
  //   clearInterval(this.inTime)
  //   this.inTime=null
  //   this.radio=1
  // },
  created() {
    this.getVcodeData();
    this.$store.commit("saveIsShow", 1);
    // 解析通过路由传入的搜索条件
    let status = "";
    Object.entries(this.$filter.deviceStatus).forEach((item) => {
      if (
        item[1].name == this.$route.query.status ||
        item[1].label == this.$route.query.status
      ) {
        status = item[0];
      } else {
        status = "0";
      }
    });
    this.search.status = status;

    this.getDeviceList();
    this.queryDeviceStatus();
    this.showHides();
   
    
    if(this.$store.state.user.dealerVcode == '08'){
       this.deviceStatusNew.standby.notVisable = true;
       this.deviceStatusNew.faultCount.notVisable = true;
    }
  },
  updated() {
    if (this.$refs.multipleSnTable && this.$refs.multipleSnTable.doLayout) {
      this.$refs.multipleSnTable.doLayout();

    }
  },
  beforeDestroy() {
    clearInterval(this.interval); // 在组件销毁之前清除定时器
  },
  methods: {
    // 升级成功关闭升级弹窗
    closeUpgradeSuccess() {
      this.upgradeDeviceSucVisible = false;
      this.intelligenceUpgradeVisible = false;
    },
    // 升级失败关闭升级弹窗
    closeUpgradeFail() {
      this.upgradeDeviceFailVisible = false;
      this.intelligenceUpgradeVisible = false;
    },
    // 智能升级提交
    submitIntelligenceUpgrade(upgrade,firmwareName,firmwareId){
      let params = {
        pn: this.dataparams.pn,
        sn: this.dataparams.sn,
        devcode: this.dataparams.devcode,
        devaddr: this.dataparams.devaddr,
        firmwareId: firmwareId,
        adaptiveUpgrade: upgrade,
        adaptiveFirmwareName: firmwareName,
      }
      this.$request.postUPG("/upg/api/auth/web/device/upgradeTransmission",params).then(res => { 
        if (res.code == 0) {
          if (res.data.status == 0) {
            this.keyProgress = res.data.key;
            this.$message.success(this.$t("device.Upgrading"));
            this.queryProgress();
          } else if (res.data.status == 1) {
            this.$message.error(this.$t("device.System_Failed"));
            this.upgradebButtonStatus = false;
          } else if (res.data.status == 2) {
            this.$message.error(this.$t("device.Device_Offline"));
            this.upgradebButtonStatus = false;
          } else if (res.data.status == 3) {
            this.$message.error(this.$t("device.In_Upgrading"));
            this.upgradebButtonStatus = false;
          }
        } else {
          this.$message.error(res.message);
          this.upgradebButtonStatus = false;
        }
      })
    },
    // 智能升级
    intelligenceUpgrade(info){
      this.intelligenceUpgradeInfo={
        firmwareId:'',
        firmwareName:'',
        needConfirm:false,
        confirmMessage:'',
        qlfuResponse:'',
      }
      this.resultTitle=''
      this.intelligenceUpgradeVisible=true
      console.log('intelligenceUpgrade', info)
      this.progerssComplete = false;
      // 增：批量升级标记
      this.upgradeDeviceBatchSign = false;
      this.progress = 0;
      this.dataparams = info;
      this.$store.commit('saveUpgradeTypeUPG', true);
      this.queryDeviceUpgradeStatus(info)
      let params = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      }
      this.$request.postUPG("/upg/api/auth/web/device/firmware/adaptive/detect",params).then(res => { 
        if (res.code==0) {
          if (res.data&&res.data.firmwareName) {
            this.intelligenceUpgradeInfo=res.data
          }
          if (!res.data.firmwareName) {
            this.$message.error(this.$t("menu.intelligenceUpgradeTitle"));
          }
        } else {
          if (this.progress) {
            
          }else{
            this.$message.error(res.message);
          }
        }
      })
    },
    // 确认固件升级
    submitIntelligenceUpgradeDevice() {
      if (!this.intelligenceUpgradeInfo.firmwareName) {
        this.$message.error(this.$t("menu.intelligenceUpgradeTitle2"));
      }else{
        this.resultTitle = ""
        this.flag = true;
        this.upgradebButtonStatus = true;
        this.submitIntelligenceUpgrade(true,this.intelligenceUpgradeInfo.firmwareName,this.intelligenceUpgradeInfo.firmwareId)

      }
    },
    Passwordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.form.pwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.form.pwd) &&
          reg2.test(this.form.pwd) &&
          reg3.test(this.form.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.form.pwd) && reg2.test(this.form.pwd)) ||
          (reg1.test(this.form.pwd) && reg3.test(this.form.pwd)) ||
          (reg2.test(this.form.pwd) && reg3.test(this.form.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.form.pwd) ||
          reg2.test(this.form.pwd) ||
          reg3.test(this.form.pwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    NewPasswordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.resetform.newpwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.resetform.newpwd) &&
          reg2.test(this.resetform.newpwd) &&
          reg3.test(this.resetform.newpwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.resetform.newpwd) &&
            reg2.test(this.resetform.newpwd)) ||
          (reg1.test(this.resetform.newpwd) &&
            reg3.test(this.resetform.newpwd)) ||
          (reg2.test(this.resetform.newpwd) && reg3.test(this.resetform.newpwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.resetform.newpwd) ||
          reg2.test(this.resetform.newpwd) ||
          reg3.test(this.resetform.newpwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    pwdcheck() {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    //打开重置密码按钮
    resetpwd(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("reset_password")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.showResetpwdDialog = true;
      this.params = info;
      this.resetform.usr = info.usr;
      this.resetform.newpwd = null;
      this.resetform.confPwd = null;

      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;

      // this.$nextTick(()=> {
      //   this.$refs.resetform.resetFields();
      // });
    },
    //重置密码
    resetpwdold() {
      // console.log("[cookie-secret]", cookie.getCookie("secret"));
      this.$refs.resetform.validate((valid) => {
        if (!valid) return false;
        this.$request
          .get("resetSubUsrPassword", {
            uid: this.params.uid,
            newpwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.resetform.newpwd),
                this.$store.state.user.secret
                // cookie.getCookie("secret")
              )
            ),
          })
          .then((res) => {
            if (res.err == 0) {
              // this.$message.success(this.$t("account.pwdresetsuccess"));
              this.resetPwdSucVisible = true;
              this.showResetpwdDialog = false;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.deviceTipMsg = this.$t(`errCode.${res.err}`);
              this.resetPwdFailVisible = true;
              this.showResetpwdDialog = false;
            }
          });
      });
    },
    // 解绑数采器弹窗
    unbindDatalogger(info) {
      this.unbindDataloggerVisible = true;
      this.resetDataloggerPn = info;
      this.resetDataloggerCode = "";
    },
    // 确定解绑数采器
    unbindDataloggerConfirm() {
      if (this.resetDataloggerCode === "YES") {
        this.unbindDataloggerVisible = false;
        let param = {
          pn: this.resetDataloggerPn,
          // level:1,
        };
        this.$request.get("vendorUnbindingCollector", param).then((res) => {
          if (res.err == 0) {
            this.getDeviceList();
            this.dataloggerUnbindSucVisible = true;
          } else {
            this.dataloggerUnbindFailVisible = true;
            this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
          }
        });
      } else {
        this.$message.error(this.$t(`datalogger.resetCode`));
      }
    },
    // 更多操作
    moreDevice(info) {
      this.moreDeviceInfo = { ...info };
      this.moreDeviceVisible = true;
    },
    // 控制项操作处理
    OperationStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 3) {
        return "background:#222d35;";
      }
    },
    //设备统计图点击筛选对应设备状态
    deviceStatusJump(key) {
      if (key == "normalCount") {
        this.search.status = "0";
      } else if (key == "standby") {
        this.search.status = "3";
      } else if (key == "warningCount") {
        this.search.status = "4";
      } else if (key == "faultCount") {
        this.search.status = "2";
      } else if (key == "offCount") {
        this.search.status = "1";
      } else {
        this.search.status = "";
      }
      this.getDeviceList(true);
    },
    //表格设备名称修改超出隐藏省略号颜色
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return "deviceName";
      }
    },
    //德业域名
    showHides() {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true;
      }
    },
    //勾选多项
    changeFun(val) {
      this.selectedDevice = val; // 返回的是选中的列的数组集合
      this.selectedDevice1 = val;
    },
    //循环遍历调用接口
    queryUpgradeDevice1() {
      this.selectedDevice1.forEach((item, index) => {
        let params = {
          pn: item.pn,
          devcode: item.devcode,
          devaddr: item.devaddr,
          sn: item.sn
        }
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeStatus", params)
          .then((res) => {
            // this.selectedDevice1[index].progress=res.data.progress/10+"%"
            // this.selectedDevice1[index].upgradeStatus=res.data.status

            Vue.set(this.selectedDevice1[index], 'progress', res.data.progress / 10 + "%");
            Vue.set(this.selectedDevice1[index], 'upgradeStatus', res.data.status);
          }).catch()
      })
    },
    // 导出报表
    // exportDevice() {},
    exportPlant(exportPlantParams) {
      if (this.disPermissionsLogo && !this.btnList.includes("export_report")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("export");
      // console.log("export-exportPlantParams", exportPlantParams);
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    // 导出报表
    // exportDevice() {},
    moreExportPlant(exportPlantParams) {
      if (this.disPermissionsLogo && !this.btnList.includes("export_report")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // console.log("export");
      // console.log("export-exportPlantParams", exportPlantParams);
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    // 进度
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //模糊查询设备
    queryGetDeviceList() {
      if (this.search.status || this.search.brand) {
        this.search.status = "";
        this.search.brand = "";
      } else {
        this.search.status = "";
        this.search.brand = "";
      }
      this.getDeviceList(true);
    },
    // 查询设备列表
    getDeviceList(reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        ...this.search,
        // [经销商设备管理页切换项目获取设备列表]
        plantid: this.plantidCur.plantidCur || "",
        // [经销商设备管理页切换获取关注设备列表]
        focus: this.curIsFollow.curIsFollow || "",
        // 关注设备排序
        // orderBy: 'descfocus',
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
      };
      this.loadingDevice = true;
      let method = 'get'
      this.$request.get("queryAccountInfo").then(info => {
        if (info.err == 0 && info.dat.uid == 4968931) {
          method = "knoxGet"
        }
      }).finally(() => {
        if (method === "get") {
          // 普通账号走微服务新接口（page从1开始、pageSize驼峰，返回用Fnreturndev转换）
          this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", {
            ...this.search,
            deviceStatus: this.search.status,
            // [经销商设备管理页切换项目获取设备列表]
            pid: this.plantidCur.plantidCur || "",
            // [经销商设备管理页切换获取关注设备列表]
            focus: this.curIsFollow.curIsFollow || "",
            devtype: 2304,
            page: this.pagination.currentPage,
            pageSize: this.pagination.pagesize,
          }).then((res) => {
            if (res.code == 0) {
              this.deviceList = this.Fnreturndev(res);
              this.pagination.total = res.data.total;
            } else {
              this.emptyText = true;
              this.deviceList = [];
              this.pagination.total = 0;
            }
            this.loadingDevice = false;
          });
        } else {
          // knox账号保持原接口不变
          this.$request[method]("webQueryDeviceEs", param).then((res) => {
            if (res.err === 0) {
              this.deviceList = res.dat.device;
              this.pagination.total = res.dat.total;
            } else {
              // this.$message.warning(this.$t(`errCode.${res.err}`));
              this.emptyText = true;
              this.deviceList = [];
              this.pagination.total = 0;
            }
            this.loadingDevice = false;
          });
        }
      })

    },
    // 获取设备状态
    queryDeviceStatus() {
      this.$request
        .get("webQueryDeviceStatusViewEs", {
          devtype: 2304,
          // 是否支持传项目ID进行筛选
          plantid: this.plantidCur.plantidCur,
        })
        .then((res) => {
          if (res.err == 0) {
            // deviceStatus
            for (let key in this.deviceStatusNew) {
              this.deviceStatusNew[key].num = res.dat[key];
            }
          }
        });
    },
    // 点击跳转设备改为点击展示设备详情页(含返回与跳转)
    // enterDevice(info) {
    //   // console.log("enterDevice-info", info);

    //   if (!info.uid) {
    //     this.$message.error(this.$t(`device.noAuth`));
    //     return;
    //   }
    //   this.$request
    //     .get("applyBrowsePermission", { uid: info.uid })
    //     .then(res => {
    //       if (res.err === 0) {
    //         // console.log('管理员进入设备', res.dat)
    //         let routeUrl = this.$router.resolve({
    //           // path: "/general/home",
    //           path: "/generalNew/home",
    //           query: {
    //             secret: res.dat.secret,
    //             token: res.dat.token,
    //             role: res.dat.role,
    //             pprAuth: res.dat.pprAuth,
    //             devcode: info.devcode,
    //             pn: info.pn,
    //             devaddr: info.devaddr,
    //             sn: info.sn
    //           }
    //         });
    //         window.open(routeUrl.href, "_blank");
    //       } else {
    //         this.$message.error(this.$t(`errCode.${res.err}`));
    //       }
    //     });
    // },
    enterDevice(info) {
      // console.log("show=>singleBox(device)");
      //查看设备信息
      // this.$store.commit("saveDeviceInfo", {
      //   pn: info.pn, //
      //   sn: info.sn, //
      //   devaddr: info.devaddr, //
      //   devcode: info.devcode, //
      //   status: info.status, //
      //   devalias: info.devalias, //
      //   pid: info.pid, //
      //   focus: info.focus, //
      //   usr: info.usr, //
      //   uid: info.uid, //
      //   // 增
      //   brand: info.brand, //
      //   // 增
      //   devtype: info.devtype, //
      //   // 增
      //   Firmware_Version: info.Firmware_Version, //
      //   // 增
      //   collalias: info.collalias, //
      // });
      // // 通知显示设备信息页(隐藏table)
      // this.$emit('noticeSingleBox', true);
      //跳转用户界面
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then((res) => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
              },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 编辑设备
    editDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("edit_devcie")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.editDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 更多操作编辑设备
    moreEditDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("edit_devcie")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.moreEditDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 业主变更
    moreOwnerShip(info){
      this.moreOwnerShipVisible = true
      this.formOwnerShip = { ...info[0] };
      this.formOwnerShip.newUid = '';
      this.ownerPage = 0;
      this.ownerSelectList = [];
      this.hasMoreOwner = true;
      this.ownerSearchKeyword = '';
    },
    // 分页查询下属业主
    getQueryOwner(isLoadMore = false){
      if (!this.hasMoreOwner) return;
      this.ownerLoading = true;
      let parma={
        page: this.ownerPage,
        pagesize: 50,
        role:0,
        devtype:2304,
      }
      if (this.ownerSearchKeyword) {
        parma.keyword = this.ownerSearchKeyword;
      }
      this.$request.get('webQueryUsrEs', parma).then(res => { 
        this.ownerLoading = false;
        if (res.err==0) {
          if (res.dat&&res.dat.account){
            if (isLoadMore) {
              this.ownerSelectList = [...this.ownerSelectList, ...res.dat.account];
            } else {
              this.ownerSelectList = res.dat.account;
            }
            if (res.dat.account.length < 50) {
              this.hasMoreOwner = false;
            }
          }else{
            if (!isLoadMore) {
              this.ownerSelectList = [];
            }
            this.hasMoreOwner = false;
          }
        }else{
          if (!isLoadMore) {
            this.ownerSelectList = [];
          }
          this.hasMoreOwner = false;
        }
      })
    },
    // 下拉框显示/隐藏时的处理
    handleOwnerSelectVisibleChange(visible){
      if (visible) {
        if (this.ownerSelectList.length === 0) {
          this.ownerPage = 0;
          this.hasMoreOwner = true;
          this.getQueryOwner();
        }
        // 添加滚动事件监听
        setTimeout(() => {
          const dropdownWrap = document.querySelector('.el-select-dropdown__wrap');
          if (dropdownWrap) {
            dropdownWrap.addEventListener('scroll', this.handleOwnerSelectScroll);
          }
        }, 100);
      } else {
        // 移除滚动事件监听
        const dropdownWrap = document.querySelector('.el-select-dropdown__wrap');
        if (dropdownWrap) {
          dropdownWrap.removeEventListener('scroll', this.handleOwnerSelectScroll);
        }
      }
    },
    // 下拉框滚动加载更多
    handleOwnerSelectScroll(event){
      const target = event.target;
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10 && this.hasMoreOwner && !this.ownerLoading) {
        this.ownerPage++;
        this.getQueryOwner(true);
      }
    },
    // 业主变更提交
    subbmitOwnerShip(){
      let parma={
        pn: this.formOwnerShip.pn,
        oldUid: this.formOwnerShip.uid,
        newUid: this.newOwnerUid,
      }
      this.$request.get('transferDeviceToNewOwner', parma).then(res => {
        if (res.err==0) {
          this.$message.success(this.$t("device.modifySuc"));
          this.moreOwnerShipVisible = false;
          this.moreDeviceVisible = false;
          this.getDeviceList();
        }else if(res.err ==7){
          this.$message.error(this.$t(`device.unbind_tips`));
        } else{
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      })
    },
    // 选择修改业主赋值
    handleOwnerSelectChange(value){
      this.newOwnerUid = value;
    },
    // 确定修改逆变器
    submitEditDevice() {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias,
      };
      this.$request.get("editDeviceInfo", param).then((res) => {
        if (res.err == 0) {
          // this.$message.success(this.$t("device.modifySuc"));
          // debugger;
          this.formEdit = {};
          // 通知设备列表更新
          this.$store.state.event.updateDeviceList = true;
          // 通知侧栏项目列表更新
          this.$store.state.event.updateProjectList = true;
          this.editDeviceVisible = false;
          this.moreEditDeviceVisible = false;
          this.editDeviceSucVisible = true;
          this.getDeviceList();
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.editDeviceFailVisible = true;
        }
      });
    },
    //查询此管理员的厂家编号vcode,用于控制权限
    getVcodeData() {
      this.$request.get("queryVendorCode").then((res) => {
        if (res.err == 0) {
          this.vcodeBox = res.dat.vendorcode[0].code;
          this.$store.commit("saveProducercode",this.vcodeBox)
          if (this.vcodeBox == "08") {
            this.deviceStatusNew.standby.notVisable = true;
            this.deviceStatusNew.faultCount.notVisable = true;
          }
              if (this.vcodeBox != '08') {
      this.deviceStatus = this.$filter.deviceStatus;
    }
          this.$store.commit("saveUserInfo", {
            dealerVcode: res.dat.vendorcode[0].code == '08' ? (this.$store.state.user.role == 2 ? res.dat.vendorcode[0].code : '') : '',
          });
        } else {
          if (this.$store.state.user.riyueyuanPermissionMark) {
            this.deviceStatusNew.standby.notVisable = true;
            this.deviceStatusNew.faultCount.notVisable = true;
          }
        }
      });
    },
    //打开控制权限按钮
    editDeviceControl() {
      this.editDeviceControlVisible = true;
      this.CheckAllPerson = false;
      this.CheckNoPerson = false;
      this.CheckAllAdmin = false;
      this.CheckNoAdmin = false;
      this.$request.get("queryDeviceDevcodes").then((res) => {
        if (res.err == 0 && res.dat.devcode && res.dat.devcode.length > 0) {
          res.dat.devcode.forEach((item) => {
            item.desc = item.devcode + " -" + item.desc;
          });
          this.protocolAllData = res.dat.devcode;
          this.searchProtocol = this.protocolAllData[0].devcode;
          this.getProtocolData();
        } else {
          this.checkStatueData = [];
          this.protocolAllData = [];
          (this.searchProtocol = ""), (this.protocolDataShow = false);
          // this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //通过协议查询协议里面的控制项
    getProtocolData() {
      this.protocolDataShow = true;
      this.CheckAllPerson = false;
      this.CheckNoPerson = false;
      this.CheckAllAdmin = false;
      this.CheckNoAdmin = false;
      this.$request
        .get("queryDeviceCtrlFieldForDist", {
          vcode: this.vcodeBox,
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          i18n: this.$lang.currentLang,
        })
        .then((res) => {
          if (res.err == 0) {
            let CheckAllPersonBoolean = "";
            let CheckAllAdminBoolean = "";
            CheckAllPersonBoolean = res.dat.field.every(function (item) {
              return item.visable == true;
            });
            if (CheckAllPersonBoolean) {
              this.CheckAllPerson = true;
            } else {
              this.CheckAllPerson = false;
            }
            CheckAllAdminBoolean = res.dat.field.every(function (item) {
              return item.distributorPermissionFlag == true;
            });
            if (CheckAllAdminBoolean) {
              this.CheckAllAdmin = true;
            } else {
              this.CheckAllAdmin = false;
            }
            this.checkStatueData = res.dat.field;
            this.protocolIdBox = [];
            this.protocolNameBox = [];
            let personProtocolBox = [],
              adminProtocolBox = [];
            res.dat.field.forEach((item) => {
              if (item.visable) {
                personProtocolBox.push(item.name);
              }
              if (item.distributorPermissionFlag) {
                adminProtocolBox.push(item.name);
              }
              this.protocolIdBox.push(item.id);
              this.protocolNameBox.push(item.name);
            });
            this.checkPersonData = personProtocolBox;
            this.checkAdminData = adminProtocolBox;
          } else {
            this.protocolIdBox = [];
            this.checkStatueData = [];
            this.protocolDataShow = false;
          }
        });
    },
    //电站业主全部勾选
    checkAllPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: true,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = true;
            this.CheckNoPerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主全部取消
    checkNoPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: false,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = false;
            this.CheckNoPerson = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部勾选
    checkAllAdmin() {
      // console.log(this.protocolIdBox,"this.protocolIdBox1111111111111111111")
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: true,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = false;
            this.CheckAllAdmin = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部取消
    checkNoAdmin() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: false,
        })
        .then((res) => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = true;
            this.CheckAllAdmin = false;
          } else {
            this.$message.error(res.err);
          }
        });
    },
    //管理员点击单个的控制权限
    protoclAdminChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          distributorPermissionFlag: !val.distributorPermissionFlag,
        })
        .then((res) => {
          if (res.err == 0) {
            this.CheckAllAdmin = false;
            this.CheckNoAdmin = false;
            this.getProtocolData();
            this.isIndeterminateAdmin = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主点击单个的控制权限
    protoclPersonChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          visable: !val.visable,
        })
        .then((res) => {
          if (res.err == 0) {
            this.CheckNoPerson = false;
            this.CheckAllPerson = false;
            this.getProtocolData();
            this.isIndeterminatePerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 返回列表
    goList() {
      this.$store.commit("saveIsShow", 1);
    },
    // 调试设备
    debugDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("debug_device")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.$store.commit("saveIsShow", 3);
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        brand: info.brand,
        devalias: info.alias,
        collalias: info.calias,
        signal: info.signal,
        usr: info.usr,
        device_Firmware_Version: info.fireware,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
    },
    // 调试清空
    qingkong() {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi(event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDevice() {
      if (this.deviceInfo.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.deviceInfo.pn,
          devaddr: this.deviceInfo.devaddr,
          cmd: this.devDebug.cmd,
        };
        this.$request.get("sendCmdToDevice", param).then((res) => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项日期时间选择窗口关闭处理
    clickClosePicker() {
      if (this.$refs["controlDatepickerRef-system_time"]) {
        this.$refs["controlDatepickerRef-system_time"].hidePicker();
      }
      if (this.$refs["controlDatepickerRef-sys_system_time"]) {
        this.$refs["controlDatepickerRef-sys_system_time"].hidePicker();
      }
    },
    // 一键读取
    async oneClickRead() {
      this.oneClickReadFlag = true;
      this.oneClickReadTip = true;

      // 收集所有需要处理的数组
      const allTables = [
        this.tableDataBse,
        this.tableDataStd,
        this.tableDataSvs,
        this.tableDataPvs,
        this.tableDataGrd,
        this.tableDataBat,
        this.tableDataCts,
        this.tableDataLos,
        this.tableDataBas,
        this.tableDataAdv,
        this.tableDataElse,
      ];

      // 创建所有异步任务
      const allPromises = allTables
        .filter((table) => table.length > 0) // 过滤空数组
        .flatMap((table) => table.map((item) => this.huoquInverter(item))); // 展开所有调用

      // 等待所有异步任务完成
      for (let i = 0; i < allPromises.length; i++) {
        try {
          let list = await allPromises[i];
        } catch (error) {
          // 可以在这里添加错误提示
          // this.$message.error(this.$t('device.one_click_read_failed'));
        } finally {
          if (i == allPromises.length - 1) {
            this.oneClickReadFlag = false;
            this.oneClickReadTip = false;
          }
        }
      }
    },
    // 控制项
    moreControlDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("control_device")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.moreControlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then((res) => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [],
            arr6 = [],
            arr7 = [],
            arr8 = [],
            arr9 = [],
            arr10 = [],
            arr11 = [];
          tableData.forEach((field) => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                field.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field);
            } else if (s.startsWith("std_")) {
              arr2.push(field);
            } else if (s.startsWith("sys_")) {
              arr3.push(field);
            } else if (s.startsWith("pvs_")) {
              arr4.push(field);
            } else if (s.startsWith("grd_")) {
              arr5.push(field);
            } else if (s.startsWith("bat_")) {
              arr6.push(field);
            } else if (s.startsWith("cts_")) {
              arr7.push(field);
            } else if (s.startsWith("los_")) {
              arr8.push(field);
            } else if (s.startsWith("bas_")) {
              arr10.push(field);
            } else if (s.startsWith("adv_")) {
              arr11.push(field);
            } else {
              arr9.push(field);
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        } else {
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
    },
    // 控制项
    controlDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes("control_device")) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      // this.controlDevcode = info.devcode;
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
     i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then((res) => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [],
            arr6 = [],
            arr7 = [],
            arr8 = [],
            arr9 = [],
            arr10 = [],
            arr11 = [];
          tableData.forEach((field) => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach((item) => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                field.controlinter.push({
                  label: item.val,
                  value: item.key,
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field);
            } else if (s.startsWith("std_")) {
              arr2.push(field);
            } else if (s.startsWith("sys_")) {
              arr3.push(field);
            } else if (s.startsWith("pvs_")) {
              arr4.push(field);
            } else if (s.startsWith("grd_")) {
              arr5.push(field);
            } else if (s.startsWith("bat_")) {
              arr6.push(field);
            } else if (s.startsWith("cts_")) {
              arr7.push(field);
            } else if (s.startsWith("los_")) {
              arr8.push(field);
            } else if (s.startsWith("bas_")) {
              arr10.push(field);
            } else if (s.startsWith("adv_")) {
              arr11.push(field);
            } else {
              arr9.push(field);
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        } else {
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
    },
    // 控制项获取当前值
    huoquInverter(info) {
      return new Promise((resolve, reject) => {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          i18n: this.$lang.currentLang,
        };
        this.$set(info, "isLoading", true);
        // info.isLoading = true;
        this.$request
          .get("queryDeviceCtrlValue", param)
          .then((res) => {
            if (res.err == 0) {
              if (res.dat.val == "undefined" || res.dat.val == "null") {
                res.dat.val = "--";
              }
              // if(info.controlinter.length){
              //   this.$set(info, 'controlvalue', res.dat.key||res.dat.val)
              // }else{
              //   this.$set(info, 'controlvalue', res.dat.val)
              // }
              if (info.controlinter.length) {
                info.controlinter.forEach((item) => {
                  //  此处处理用的label和接口返回的val匹配忽略大小写
                  if (item.label == res.dat.val) {
                    this.$set(info, "controlvalue", item.value);
                  } else if (
                    item.label.toString().toLowerCase() ==
                    res.dat.val.toString().toLowerCase()
                  ) {
                    this.$set(info, "controlvalue", item.value);
                  }
                });
                if (!info.controlvalue)
                  this.$set(
                    info,
                    "controlvalue",
                    res.dat.val || this.$t("nodata")
                  );
              } else {
                this.$set(
                  info,
                  "controlvalue",
                  res.dat.val || this.$t("nodata")
                );
              }
              resolve();
            } else {
              if (this.oneClickReadTip) {
              } else {
                this.$message.error(this.$t(`errCode.${res.err}`));
              }
              reject();
            }
            // info.isLoading = false;
            this.$set(info, "isLoading", false);
          })
          .catch(() => {
            this.$set(info, "isLoading", false);
            if (this.oneClickReadTip) {
            } else {
              this.$message.error(this.$t(`errCode.3`));
            }
            reject();
          });
      });
    },
    // 下发指令
    xiafaInverter(info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang,
        };
        this.$set(info, "Loading", true);
        // info.Loading = true;
        this.$request
          .get("ctrlDevice", param)
          .then((res) => {
            // this.$request.get("ctrlDevice", param).then(res => {
            if (res.err == 0) {
              if (this.controlparams.devcode == 2352) {
                var medium = res.dat.dat.substring(27, 29);
                if (medium == "31") {
                  this.$message.success(this.$t("device.Send_suc"));
                } else {
                  this.$message.error(this.$t("device.Send_fail"));
                }
              } else {
                this.$message.success(this.$t("device.Send_suc"));
              }
            } else {
              if (this.controlparams.devcode == 2376) {
                if (res.desc.match(/\(([^)]*)\)/)) {
                  this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
                } else {
                  const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                  this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
                }
              } else {
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
              // this.$message.error(this.$t(`errCode.${res.err}`));
            }
            // info.Loading = false;
            this.$set(info, "Loading", false);
          })
          .catch(() => {
            this.$set(info, "Loading", false);
            this.$message.error(this.$t(`errCode.3`));
          });
      }
    },
    // 升级中的上传固件
    uploadFirmwareAdd() {
      if (
        this.disPermissionsLogo &&
        !this.btnList.includes("upload_firmware")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.dialogAdd = true;
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
        this.remark = null;
      });
    },
    voltageArr(item) {
      this.rechargelist.forEach((element) => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 新增：设备固件批量升级(多) ==========
    // 注意：批量升级是给多个设备升级同一个设备固件，如不清楚设备所适合的固件，请谨慎选择！
    upgradeDeviceBatch(info) {
      this.searchrecharge.firmwaretype = "0";
      this.searchrecharge.brate = "0";
      // console.log("[upgradeDeviceBatch]");
      // console.log("[upgradeDeviceBatch-info]", info);
      // 清空升级成功与失败列表
      this.snUpOkList = [];
      this.snUpNoList = [];
      // 标记进行批量中的下一个是否进行
      this.allowNextUpgrade = true;
      // 至少选中1条
      if (!this.selectedDevice) {
        return;
      }
      // 固件列表
      this.queryFirmware();
      // 设备批量升级标记
      this.upgradeDeviceBatchSign = true;
      // 弹窗
      this.upgradeDeviceVisible = true;
      // 进度
      this.progerssComplete = false;
    },
    queryUpgradeDevice(info) {
      this.queryUpgradeDevice1();
      // 清空升级成功与失败列表
      this.snUpOkList = [];
      this.snUpNoList = [];
      // 标记进行批量中的下一个是否进行
      this.allowNextUpgrade = true;
      // 至少选中1条
      if (!this.selectedDevice) {
        return;
      }
      // 固件列表
      this.queryFirmware();
      // 设备数据
      // this.dataparams = info;
      // 设备批量升级标记
      this.upgradeDeviceBatchSign = true;
      // 弹窗
      this.queryUpgradeDeviceVisible = true;
      // 进度
      this.progerssComplete = false;
    },
    // 新增：确认固件批量升级(多)
    submitUpgradeDeviceBatch() {
      // 当前选中 (this.selectedDevice) 循环请求
      // this.selectedDevice.forEach((item)=>{
      //   this.submitUpgradeDeviceBatchFun();
      // });

      // 升级前的情况处理..........
      // [1]已超过最大批量数
      if (this.selectedDevice.length > 100) {
        // 注意国际化
        // this.$t("datalogger.updatefail")
        this.$message.error("已超出最大批量数100");
        return;
      }
      // [2]请先选择要升级的固件
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
        return;
      }
      // [3]升级失败，采集器可能离线，或者检查是否与采集器通讯正常
      // let statusPass = this.selectedDevice.some((item) => {
      //   return item.status == "1";
      // });
      // if (statusPass) {
      //   this.$message.error(this.$t("device.updatefail"));
      //   return;
      // }

      // 升级提交..........
      // this.selectedDevice.forEach((item) => {
      //   console.log("[upgradeSn-item]", item);
      //   this.submitUpgradeDeviceBatchFun(item);
      // });

      // let index = 0;
      // if(this.selectedDevice.length > index){
      //   this.submitUpgradeDeviceBatchFun(this.selectedDevice, index);
      // }

      // 设备批量升级初次调用
      this.submitUpgradeDeviceBatchFun(this.selectedDevice, 0);
    },
    submitUpgradeDeviceBatchFun(arr, index) {
      if (arr.length == index) {
        this.progressUp = false;
        this.progerssComplete = true;
        this.progressFlag = 0
        this.resultTitle = this.$t("firmware.updateCompleted")
        return
      }

      // 升级操作
      if (arr.length > index && this.allowNextUpgrade) {
        // 标记进行批量中的下一个是否进行
        this.allowNextUpgrade = false;

        this.progress = 0;
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: arr[index].pn,
          devaddr: arr[index].devaddr,
          devcode: arr[index].devcode,
          sn: arr[index].sn,
          // 下拉选择
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("device.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // [查进度](含upgradeDeviceVisible置为false)
              // this.queryProgress();
              this.queryProgress(arr[index], index + 1);
            } else {
              let hasNoSn1 = this.snUpNoList.some((item) => {
                item == arr[index].sn;
              });
              if (!hasNoSn1) {
                this.snUpNoList.push(arr[index].sn);
              }
              // 根据选中条数判断
              if (arr.length > index) {
                // 标记进行批量中的下一个是否进行
                this.allowNextUpgrade = true;
                this.resultTitle = this.$t("firmware.upgrading")
                this.submitUpgradeDeviceBatchFun(this.selectedDevice, index + 1);
              }
            }
          } else {
            let hasNoSn1 = this.snUpNoList.some((item) => {
              item == arr[index].sn;
            });
            if (!hasNoSn1) {
              this.snUpNoList.push(arr[index].sn);
            }
            // 根据选中条数判断
            if (arr.length > index) {
              // 标记进行批量中的下一个是否进行
              this.allowNextUpgrade = true;
              this.resultTitle = this.$t("firmware.upgrading")
              this.submitUpgradeDeviceBatchFun(this.selectedDevice, index + 1);
            }
          }
        });
        // ==========
        // }

        // 递归调用
        // this.submitUpgradeDeviceBatchFun(arr, ++index);
      }
    },
    // 返回设备列表
    // goDeviceList(){
    //   // this.upgradeFlag=true
    //   this.$store.commit("saveIsShow",1)
    //   clearInterval(this.inTime)
    //   this.inTime=null
    //   this.radio=1
    // },
    // submitCloudUpgradeDevice(){
    //   this.cloudUpgradeDeviceVisible=false
    //   if (this.radio==2) {
    //     // this.upgradeFlag=false
    //     this.$store.commit("saveIsShow",2)
    //     let params={
    //       devaddr:this.upgradeData.devaddr,
    //       devcode:this.upgradeData.devcode,
    //       pn:this.upgradeData.pn,
    //       sn:this.upgradeData.sn,
    //     }
    //     this.$request.getUPG("/upg/api/auth/web/device/upgradeStatus",params).then(res=>{
    //       if (res.code==0) {
    //         this.cloudsUpgradeData=res.data
    //         this.cloudsUpgradeStatus=res.data.status
    //         if (res.data.status==0) {
    //           let id="/upg/api/auth/web/device/upgradeRecord/"+res.data.id
    //           this.$request.getUPG(id).then(res=>{
    //             if (res.code==0) {
    //               this.cloudsUpgradeName=res.data.firmwareName
    //             }
    //           })
    //         }
    //       }
    //     })
    //   }else{
    //     this.queryFirmware();
    //     this.cloudUpgradeDeviceVisible=false
    //     this.upgradeDeviceVisible = true;
    //     // 增：批量升级标记
    //     this.upgradeDeviceBatchSign = false;
    //     this.progerssComplete = false;
    //   }
    // },
    // 设备固件升级(单) ==========
    upgradeDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes('upgrade_device')) {
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      Object.assign(this.$data.firmwaretypelist, this.$options.data.call(this).firmwaretypelist)
      Object.assign(this.$data.firmwaretypelist1, this.$options.data.call(this).firmwaretypelist1)
      this.searchrecharge.firmwaretype = "0"
      this.searchrecharge.brate = "0"
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType/${info.devcode}`).then(res => {
        if (res.code == 0) {
          if (res.data.items && res.data.items.length != 0) {
            this.$store.commit('saveUpgradeUPG', true);
            res.data.items.map(item => {
              item.value = item.id;
              item.label = item.typeName;
            });
            this.firmwaretypelist = res.data.items
            this.searchrecharge.firmwaretype = res.data.items[0].id
            this.queryFirmware();
            this.queryDeviceUpgradeStatus(info)
          } else {
            this.$store.commit('saveUpgradeUPG', false);
            // this.$request.get(`queryDevUpMode`, { pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr, }).then(res => {
            this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr}).then(res=>{
              if (res.code == 0) {
                if (res.data == 1) {
                  this.$store.commit('saveUpgradeTypeUPG', true);
                  this.getUpgFirmwaretypeNom(info)
                } else {
                  this.$store.commit('saveUpgradeTypeUPG', false);
                }
              } else {
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
              this.queryFirmware();
              this.queryDeviceUpgradeStatus(info)
            })
          }
        } else {
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`, { pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr, }).then(res => {
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr}).then(res=>{
            if (res.code == 0) {
              if (res.data == 1) {
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom(info)
              } else {
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
            } else {
              this.$store.commit('saveUpgradeTypeUPG', false);
            }
            this.queryFirmware();
            this.queryDeviceUpgradeStatus(info)
          })
        }
      }).catch(() => {
        this.$store.commit('saveUpgradeTypeUPG', false);
        this.queryFirmware();
        this.queryDeviceUpgradeStatus(info)
      })
      this.dataparams = info;
      this.upgradeDeviceVisible = true;
      // 增：批量升级标记
      this.upgradeDeviceBatchSign = false;
      this.progerssComplete = false;
    },
    // 设备固件升级(单) ==========
    moreUpgradeDevice(info) {
      if (this.disPermissionsLogo && !this.btnList.includes('upgrade_device')) {
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      Object.assign(this.$data.firmwaretypelist, this.$options.data.call(this).firmwaretypelist)
      Object.assign(this.$data.firmwaretypelist1, this.$options.data.call(this).firmwaretypelist1)
      this.searchrecharge.firmwaretype = "0"
      this.searchrecharge.brate = "0"
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType/${info.devcode}`).then(res => {
        if (res.code == 0) {
          if (res.data.items && res.data.items.length != 0) {
            this.$store.commit('saveUpgradeUPG', true);
            res.data.items.map(item => {
              item.value = item.id;
              item.label = item.typeName;
            });
            this.firmwaretypelist = res.data.items
            this.searchrecharge.firmwaretype = res.data.items[0].id
            this.queryFirmware();
            this.queryDeviceUpgradeStatus(info)
          } else {
            this.$store.commit('saveUpgradeUPG', false);
            // this.$request.get(`queryDevUpMode`, { pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr, }).then(res => {
            this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr}).then(res=>{
              if (res.code == 0) {
                if (res.data == 1) {
                  this.$store.commit('saveUpgradeTypeUPG', true);
                  this.getUpgFirmwaretypeNom(info)
                } else {
                  this.$store.commit('saveUpgradeTypeUPG', false);
                }
              } else {
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
              this.queryFirmware();
              this.queryDeviceUpgradeStatus(info)
            })
          }
        } else {
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`, { pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr, }).then(res => {
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn: info.pn, sn: info.sn, devcode: info.devcode, devaddr: info.devaddr}).then(res=>{
            if (res.code == 0) {
              if (res.data == 1) {
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom(info)
              } else {
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
            } else {
              this.$store.commit('saveUpgradeTypeUPG', false);
            }
            this.queryFirmware();
            this.queryDeviceUpgradeStatus(info)
          })
        }
      }).catch(() => {
        this.$store.commit('saveUpgradeTypeUPG', false);
        this.queryFirmware();
        this.queryDeviceUpgradeStatus(info)
      })
      this.dataparams = info;
      this.moreUpgradeDeviceVisible = true;
      // 增：批量升级标记
      this.upgradeDeviceBatchSign = false;
      this.progerssComplete = false;
    },
    getUpgFirmwaretypeNom(info) {
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType`).then(res => {
        if (res.code == 0) {
          if (res.data.items && res.data.items.length != 0) {
            var arrList = []
            res.data.items.forEach((element, index) => {
              if (element.id==3&&info.otaLabel==1) {
                
              }else{
                arrList.push({
                  value: element.id,
                  label: element.typeName,
                  id: element.id,
                })
              }
            })
            this.firmwaretypelist = arrList
            this.searchrecharge.firmwaretype = this.firmwaretypelist[0].value
          }
        }
      });
    },
    // 查询设备升级状态
    queryDeviceUpgradeStatus(info) {
      let params = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      }
      if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeStatus", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                this.keyProgress = res.data.key;
                this.upgradebButtonStatus = true;
                this.queryProgress();
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
              }
            }
          });
      } else {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeStatus", params).then(res => {
          if (res.code == 0) {
            if (res.data.status == 0) {
              this.keyProgress = res.data.key
              this.upgradebButtonStatus = true;
              this.getQueryFirmware()
              this.queryProgress()
            }
          }
        })
      }
    },
    //查询设备升级固件
    getQueryFirmware() {
      let key = this.keyProgress
      this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryFirmwareByKey", { key }).then(res => {
        this.searchrecharge.firmware = res.data.firmwareId
        if (this.hideFlag) {
          this.firmwaretypelist1.forEach((item) => {
            if (item.value == res.data.firmwareCode) {
              this.searchrecharge.firmwaretype = item.label
            }
          })
        } else {
          this.firmwaretypelist.forEach((item) => {
            if (item.value == res.data.firmwareCode) {
              this.searchrecharge.firmwaretype = item.label
            }
          })
        }
        this.bratelist.forEach((item) => {
          if (item.value == res.data.brate) {
            this.searchrecharge.brate = item.label
          }
        })
      })
    },
    // 日月元透传升级
    // upgradeDevice (info) {
    //   this.cloudsUpgradeName=''
    //   this.cloudsUpgradeStatus={}
    //   let action="/upg/api/auth/web/device/upgradeType/"+info.devcode
    //   this.$request
    //   .getUPG(action)
    //   .then(res => {
    //     if (res.code == 0) {
    //       // 通过协议获取升级方式
    //       // this.firmwaresData = res.data.items;
    //       if (res.data.items.length>0) {
    //         this.cloudsfirmwaretypelist=res.data.items
    //         this.upgradeData=info
    //         this.dataparams = info;
    //         this.cloudUpgradeDeviceVisible=true
    //       }else{
    //         this.queryFirmware();
    //         this.dataparams = info;
    //         this.upgradeDeviceVisible = true;
    //         // 增：批量升级标记
    //         this.upgradeDeviceBatchSign = false;
    //         this.progerssComplete = false;
    //       }
    //     }else{
    //       this.queryFirmware();
    //       this.dataparams = info;
    //       this.upgradeDeviceVisible = true;
    //       // 增：批量升级标记
    //       this.upgradeDeviceBatchSign = false;
    //       this.progerssComplete = false;
    //     }
    //   }).catch(()=>{
    //     this.queryFirmware();
    //     this.dataparams = info;
    //     this.upgradeDeviceVisible = true;
    //     // 增：批量升级标记
    //     this.upgradeDeviceBatchSign = false;
    //     this.progerssComplete = false;
    //   });
    // },
    // // 获取云端升级固件包
    // getCloudsUpgrade(){
    //   let parmas={
    //     deleteFlag:0,
    //     pageSize:100,
    //     page:1
    //   }
    //   this.$request
    //   .getUPG("/upg/api/auth/web/device/firmwares", parmas)
    //   .then(res => {
    //     if (res.code == 0) {
    //       this.firmwaresData = res.data.items;
    //     }
    //   });
    // },
    // // 设备云端升级
    // cloudsUpgradeDevice (info) {
    //   this.$nextTick(()=>{
    //     this.$refs.createFirmwareUpgrade.resetFields();
    //   })
    //   this.getCloudsUpgrade()
    //   this.searchclouds.firmwareId=""
    //   this.searchclouds.firmwareType=""
    //   this.searchclouds.baudrate="0"
    //   // this.getCloudsUpgradeType()
    //   this.cloudsUpgradeDeviceVisible = true;
    // },
    // // 中断继续升级
    // continueCloudsUpgradeDevice (info) {
    //   this.$nextTick(()=>{
    //     this.$refs.continueFirmwareUpgrade.resetFields();
    //   })
    //   this.continueCloudUpgradeDeviceVisible=true,
    //   this.getCloudsUpgrade()
    //   this.searchclouds.firmwareId=""
    //   this.searchclouds.firmwareType=""
    //   this.searchclouds.baudrate="0"
    //   this.searchclouds.step=''
    // },
    // // 继续云端升级提交
    // submitContinueCloudsUpgradeDevice(){
    //   this.$refs.continueFirmwareUpgrade.validate((valid)=>{
    //     if (!valid) return false;
    //     this.submitCloudsUpgradeDeviceDisabled=true
    //     let params={
    //       step:this.searchclouds.step,
    //       firmwareId:this.searchclouds.firmwareId,
    //       pn:this.upgradeData.pn,
    //       sn:this.upgradeData.sn,
    //       devaddr:this.upgradeData.devaddr,
    //       devcode:this.upgradeData.devcode,
    //       baudrate:this.searchclouds.baudrate,
    //       firmwareType:this.searchclouds.firmwareType,
    //     }
    //     this.$request.postUPG('/upg/api/auth/web/device/upgradeTransmission',params).then(res=>{
    //       if (res.code==0) {
    //         this.cloudsUpgradeData=res.data
    //         this.$message.success(this.$t("device.continueUpgradeSuccess"))
    //           let params={
    //             key:res.data.key,
    //             pn:this.upgradeData.pn,
    //           }
    //           this.$request.getUPG("/upg/api/auth/web/device/upgradeProgressByKey",params).then(res=>{
    //             if (res.code==0) {
    //               this.cloudsUpgradeStatus=res.data.status
    //             }
    //           })
    //           this.firmwaresData.forEach((item)=>{
    //             if (item.id==this.searchclouds.firmwareId) {
    //               this.cloudsUpgradeName=item.firmwareName
    //             }
    //           })
    //       }else{
    //         this.$message.error(res.message)
    //       }
    //       this.continueCloudUpgradeDeviceVisible = false;
    //       this.submitCloudsUpgradeDeviceDisabled=false
    //     }).catch(()=>{
    //       this.submitCloudsUpgradeDeviceDisabled=false
    //     })
    //   })

    // },
    // // 云端升级提交
    // submitCloudsUpgradeDevice(){
    //   this.$refs.createFirmwareUpgrade.validate((valid)=>{
    //     if (!valid) return false;
    //     this.submitCloudsUpgradeDeviceDisabled=true
    //     let params={
    //       firmwareId:this.searchclouds.firmwareId,
    //       pn:this.upgradeData.pn,
    //       sn:this.upgradeData.sn,
    //       devaddr:this.upgradeData.devaddr,
    //       devcode:this.upgradeData.devcode,
    //       baudrate:this.searchclouds.baudrate,
    //       firmwareType:this.searchclouds.firmwareType,
    //     }
    //     this.$request.postUPG('/upg/api/auth/web/device/upgradeTransmission',params).then(res=>{
    //       if (res.code==0) {
    //         this.cloudsUpgradeData=res.data
    //         this.$message.success(this.$t("device.addUpgradeSuccess"))
    //           let params={
    //             key:res.data.key,
    //             pn:this.upgradeData.pn,
    //           }
    //           this.$request.getUPG("/upg/api/auth/web/device/upgradeProgressByKey",params).then(res=>{
    //             if (res.code==0) {
    //               this.cloudsUpgradeStatus=res.data.status
    //             }
    //           })
    //           this.firmwaresData.forEach((item)=>{
    //             if (item.id==this.searchclouds.firmwareId) {
    //               this.cloudsUpgradeName=item.firmwareName
    //             }
    //           })
    //       }else{
    //         this.$message.error(res.message)
    //       }
    //       this.cloudsUpgradeDeviceVisible = false;
    //       this.submitCloudsUpgradeDeviceDisabled=false
    //     }).catch(()=>{
    //       this.submitCloudsUpgradeDeviceDisabled=false
    //     })
    //   })

    // },
    // 查询固件列表
    queryFirmware() {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      this.loadingupgradeDev = true;
      const allItems = [];
      const pagesize = 100;
      // firmwares接口page从1开始，参数为page/pageSize
      const fetchUPG = async () => {
        let page = 1;
        while (true) {
          let parmas = { page, pageSize: pagesize };
          let res = await this.$request.getUPG("/upg/api/auth/web/device/firmwares", parmas);
          if (res.code == 0 && Array.isArray(res.data.items)) {
            res.data.items.forEach(item => {
              allItems.push({
                id: item.id,
                firmware: item.firmwareName,
                size: item.fileSize
              });
            });
            if (res.data.items.length < pagesize) break;
            page++;
          } else {
            break;
          }
        }
      };
      // queryFiremware接口page从0开始，参数为page/pagesize
      const fetchDess = async () => {
        let page = 0;
        while (true) {
          let parmas = { page, pagesize };
          let res = await this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", parmas);
          if (res.code == 0 && Array.isArray(res.data.items)) {
            res.data.items.forEach(item => {
              allItems.push({
                id: item.id,
                firmware: item.firmware,
                size: item.size
              });
            });
            if (res.data.items.length < pagesize) break;
            page++;
          } else {
            break;
          }
        }
      };
      (async () => {
        if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
          await fetchUPG();
        } else {
          await fetchDess();
        }
        this.rechargelist = allItems;
        this.loadingupgradeDev = false;
      })();
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
        let parmas = {
          firmwareName: file.name,
          versionNote: 'V1.0',
          deleteFlag: '0',
          upgradeMode: 1,
          note: this.desc,
        }
        this.$request.uploadFirmware('/upg/api/auth/web/device/firmware', file, parmas).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t("device.uploadSuccess"));
            // this.upgradeDeviceVisible = false;
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else if (res.code === 6) {
            this.$message.error(this.$t("device.error1"));
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else {
            this.$message.error(res.message);
            // 关闭二次弹窗
            this.dialogAdd = false;
          }
          this.queryFirmware();
        });
      } else {
        this.$request.uploadfileAxios(file, this.desc, this.remark).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t("device.uploadSuccess"));
            // this.upgradeDeviceVisible = false;
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else if (res.code === 6) {
            this.$message.error(this.$t("device.error1"));
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // 关闭二次弹窗
            this.dialogAdd = false;
          }
          this.queryFirmware();
          // this.upgradeDeviceVisible = false;
        });
      }

    },
    // 确认固件升级
    submitUpgradeDevice() {
      this.resultTitle = ""
      this.flag = true;
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        this.upgradebButtonStatus = true;
        if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
          let UPGparams = {
            pn: this.dataparams.pn,
            devaddr: this.dataparams.devaddr,
            devcode: this.dataparams.devcode,
            sn: this.dataparams.sn,
            firmwareId: this.searchrecharge.firmware,
            firmwareType: this.searchrecharge.firmwaretype,
            baudrate: this.searchrecharge.brate
          };
          // 接入UPG升级
          this.$request
            .postUPG("/upg/api/auth/web/device/upgradeTransmission", UPGparams)
            .then(res => {
              if (res.code == 0) {
                if (res.data.status == 0) {
                  this.keyProgress = res.data.key;
                  this.$message.success(this.$t("device.Upgrading"));
                  this.queryProgress();
                } else if (res.data.status == 1) {
                  this.$message.error(this.$t("device.System_Failed"));
                  this.upgradebButtonStatus = false;
                } else if (res.data.status == 2) {
                  this.$message.error(this.$t("device.Device_Offline"));
                  this.upgradebButtonStatus = false;
                } else if (res.data.status == 3) {
                  this.$message.error(this.$t("device.In_Upgrading"));
                  this.upgradebButtonStatus = false;
                }
              } else {
                this.$message.error(res.message);
                this.upgradebButtonStatus = false;
              }
            });
        } else {
          let params = {
            pn: this.dataparams.pn,
            devaddr: this.dataparams.devaddr,
            devcode: this.dataparams.devcode,
            sn: this.dataparams.sn,
            firmwareId: this.searchrecharge.firmware,
            firmwareType: this.searchrecharge.firmwaretype,
            baudrate: this.searchrecharge.brate
          };
          this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
            if (res.code == 0) {
              if (res.data.ret == 0) {
                this.keyProgress = res.data.key;
                this.$message.success(this.$t("device.Upgrading"));
                this.queryProgress();
              } else if (res.data.ret == 1) {
                this.$message.error(this.$t("device.System_Failed"));
                this.upgradebButtonStatus = false;
              } else if (res.data.ret == 2) {
                this.$message.error(this.$t("device.Device_Offline"));
                this.upgradebButtonStatus = false;
              } else if (res.data.ret == 3) {
                this.$message.error(this.$t("device.In_Upgrading"));
                this.upgradebButtonStatus = false;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              this.upgradebButtonStatus = false;
            }
          });
        }

      }
    },
    // 查询升级进度(增加批量标志)
    queryProgress(info, curIndex) {
      this.progressUp = true;
      this.progerssComplete = false;
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
        let params = {
          pn: this.dataparams.pn,
          // devaddr: this.dataparams.devaddr,
          // devcode: this.dataparams.devcode,
          // sn: this.dataparams.sn,
          key: this.keyProgress
        };
        this.interval = setInterval(() => {
          this.$request
            .getUPG("/upg/api/auth/web/device/upgradeProgressByKey", params)
            .then(res => {
              if (res.code == 0) {
                if (res.data.status == 0) {
                  // this.upgradebButtonStatus = true;
                  let progress =
                    this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                  this.progress = progress;
                  this.uploadNowSize = this.$filter.formatNum(
                    (this.uploadTotalSize * progress) / 100,
                    2
                  );
                  if (this.progress >= 100) {
                    this.progressFlag = res.data.status
                    clearInterval(this.interval);
                    this.interval = null;
                    this.upgradebButtonStatus = false;
                    this.progressUp = false;
                    this.uploadNowSize = this.uploadTotalSize;
                    this.progerssComplete = true;
                    this.progressSuc();
                    this.resultTitle = this.$t("firmware.updateCompleted")
                    return;
                  }
                } else if (res.data.status == 1) {
                  // =》'升级异常，已退出'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  this.resultTitle = this.$t("firmware.upgrade_quit1")
                  return;
                } else if (res.data.status == 2) {
                  // =》'升级失败,请稍后再试'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  this.resultTitle = this.$t("firmware.upgrade_quit2")
                  return;
                } else if (res.data.status == 3) {
                  // =》'升级成功'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  this.resultTitle = this.$t("firmware.upgrade_quit3")
                  return;
                } else if (res.data.status == 4) {
                  // =》'升级被手动取消'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  this.resultTitle = this.$t("firmware.upgrade_quit4")
                  return;
                } else if (res.data.status == 5) {
                  // =》'未在升级中'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  this.resultTitle = this.$t("firmware.upgrade_quit5")
                  return;
                }
              }
              // else if(res.code == 2){
              //   // 为什么要写一个空判断呢？
              // } 
              else {
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle = this.$t(`errCode.${res.err}`)
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
              }
            });
        }, 2000);

      } else {
        let params = {
          // 查设备升级进度所需参数
          pn: info ? info.pn : this.dataparams.pn,
          devaddr: info ? info.devaddr : this.dataparams.devaddr,
          devcode: info ? info.devcode : this.dataparams.devcode,
          sn: info ? info.sn : this.dataparams.sn,
          key: this.keyProgress
        };
        this.interval = setInterval(() => {
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
            .then(res => {
              if (res.code == 0) {
                if (res.data.status == 0) {
                  // this.upgradebButtonStatus = true;
                  let progress = this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                  this.progress = progress;
                  this.uploadNowSize = this.$filter.formatNum(
                    (this.uploadTotalSize * progress) / 100,
                    2
                  );
                  if (this.progress >= 100) {
                    this.progressFlag = res.data.status
                    clearInterval(this.interval);
                    this.interval = null;
                    this.upgradebButtonStatus = false;
                    this.progressUp = false;
                    this.uploadNowSize = this.uploadTotalSize;
                    this.progerssComplete = true;
                    this.progressSuc();
                    this.resultTitle = this.$t("firmware.updateCompleted")
                    // 显示升级成功的设备Sn 
                    let hasOkSn0 = this.snUpOkList.some((item) => {
                      item == params.sn;
                    });
                    if (!hasOkSn0) {
                      this.snUpOkList.push(params.sn);
                    }
                    // 根据选中条数判断
                    if (this.selectedDevice.length > curIndex) {
                      // 标记进行批量中的下一个是否进行
                      this.allowNextUpgrade = true;
                      this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                    } else {
                      // 升级操作完毕
                      this.progressUp = false;
                      this.progerssComplete = true;
                    }
                    return;
                  }
                } else if (res.data.status == 1) {
                  // =》'升级异常，已退出'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 显示升级失败的设备Sn 
                  let hasNoSn1 = this.snUpNoList.some((item) => {
                    item == params.sn;
                  });
                  if (!hasNoSn1) {
                    this.snUpNoList.push(params.sn);
                  }
                  // 根据选中条数判断
                  if (this.selectedDevice.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  this.resultTitle = this.$t("firmware.upgrade_quit1")
                  return;
                } else if (res.data.status == 2) {
                  // =》'升级失败,请稍后再试'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 显示升级失败的设备Sn 
                  let hasNoSn2 = this.snUpNoList.some((item) => {
                    item == params.sn;
                  });
                  if (!hasNoSn2) {
                    this.snUpNoList.push(params.sn);
                  }
                  // 根据选中条数判断
                  if (this.selectedDevice.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  this.resultTitle = this.$t("firmware.upgrade_quit2")
                  return;
                } else if (res.data.status == 3) {
                  // =》'升级成功'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 显示升级成功的设备Sn 
                  let hasOkSn3 = this.snUpOkList.some((item) => {
                    item == params.sn;
                  });
                  if (!hasOkSn3) {
                    this.snUpOkList.push(params.sn);
                  }
                  // 根据选中条数判断
                  if (this.selectedDevice.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  this.resultTitle = this.$t("firmware.upgrade_quit3")
                  return;
                } else if (res.data.status == 4) {
                  // =》'升级被手动取消'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 显示升级失败的设备Sn 
                  let hasNoSn4 = this.snUpNoList.some((item) => {
                    item == params.sn;
                  });
                  if (!hasNoSn4) {
                    this.snUpNoList.push(params.sn);
                  }
                  // 根据选中条数判断
                  if (this.selectedDevice.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  this.resultTitle = this.$t("firmware.upgrade_quit4")
                  return;
                } else if (res.data.status == 5) {
                  // =》'未在升级中'
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  // 显示升级失败的设备Sn 
                  let hasNoSn5 = this.snUpNoList.some((item) => {
                    item == params.sn;
                  });
                  if (!hasNoSn5) {
                    this.snUpNoList.push(params.sn);
                  }
                  // 根据选中条数判断
                  if (this.selectedDevice.length > curIndex) {
                    // 标记进行批量中的下一个是否进行
                    this.allowNextUpgrade = true;
                    this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                  } else {
                    // 升级操作完毕
                    this.progressUp = false;
                    this.progerssComplete = true;
                  }
                  this.resultTitle = this.$t("firmware.upgrade_quit5")
                  return;
                }
              }
              // else if(res.code == 2){
              //   //这里也是 为什么要写一个空判断呢？
              // } 
              else {
                // 根据选中条数判断
                if (this.selectedDevice.length > curIndex) {
                  // 标记进行批量中的下一个是否进行
                  this.allowNextUpgrade = true;
                  this.submitUpgradeDeviceBatchFun(this.selectedDevice, curIndex);
                } else {
                  // 升级操作完毕
                  this.progressUp = false;
                  this.progerssComplete = true;
                  // this.resultTitle=this.$t(`errCode.${res.code}`)
                  this.resultTitle = res.message

                }
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
              }
            });
        }, 2000);
      }

    },
    progressSuc() {
      if (this.flag) {
        this.$message.success(this.$t("device.Update_Completed"));
        this.flag = false;
      }
    },
    //取消升级
    upgradeCancel() {
      if (this.upgradeUPG.upgradeUPG || this.UpgradeTypeUPG.UpgradeTypeUPG) {
        let parmas = {
          pn: this.dataparams.pn,
          key: this.keyProgress
        }
        this.$request.putUPG(`/upg/api/auth/web/device/upgradeCancel`, parmas).then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        })
      } else {
        this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
          .then(res => {
            if (res.code == 0) {
              // =》'取消升级成功'
              this.progressUp = false
              clearInterval(this.interval);
              this.upgradebButtonStatus = false;
              this.intelligenceUpgradeVisible = false;
              this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
            } else if (res.code == 3 || res.code == 1) {
              this.upgradeDeviceVisible = false;
              // 增：批量升级标记
              this.upgradeDeviceBatchSign = false;
            } else {
              // =》'取消升级失败'
              this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
            }
          });
      }
    },
    deleteDevice(info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn
      };
      // this.deleteDeviceVisible = true;
    },
    // 确定删除逆变器
    submitDeleteDevice() {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then((res) => {
          if (res.err == 0) {
            // this.$message.success(this.$t("device.deleteSuc"));
            // this.deleteDeviceVisible = false;
            this.delDeviceSucVisible = true;
            this.deletingDeviceInfo = null;
            this.getDeviceList();
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.delDeviceFailVisible = true;
          }
        });
    },
    // 关于搜索弹窗 =====
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      this.search.pn = "";
      this.search.status = "";
      this.search.usr = "";
      this.search.brand = "";
      this.search.search = "";
      this.getDeviceList();
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 关闭批量操作弹条
    closeBatch() {
      this.$refs.multipleSnTable.clearSelection();
    },
    // 给下发指令该列增加样式
    // (row, column, rowIndex, columnIndex)
    changeCellStyle(row) {
      if (row.column.label == i18n.t("device.Send_Command")) {
        return "background: linear-gradient(0deg, rgba(60, 75, 87, 1) 5.36%, rgba(42, 54, 63, 1) 100%);box-shadow: -1px -1px 11px rgba(74, 74, 74, 0.06), 0px 4px 4px rgba(0, 0, 0, 0.25);";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.deviceNew {
  .instructieClass {
    display: flex;
    max-width: 300px;
  }

  .debugInfo {
    display: flex;
    flex: 1;
    flex-direction: column;

    .deviceHeader {
      display: flex;
      font-size: 20px;
      color: #ffffff;
      justify-content: space-between;
      align-items: center;
      background-color: #222d35;

      .deviceHeaderLeft {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        div:last-child {
          padding-left: 30px;
          font-weight: 700;
        }

        .closepage {
          display: inline-block;
          background-color: #23323d;
          width: 60px;
          height: 56px;
          background-image: url("../../../assets/img/general/arrow_left.png");
          background-size: 24px 24px;
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer;
        }
      }
    }

    .deviceBody {
      height: 100%;
      background-color: #222d35;
      margin-top: 10px;
      padding: 20px 500px 20px 110px;
      color: #fff;

      .devaddrClass {
        width: 200px;
      }

      /deep/.el-form-item__label {
        color: #fff;
        height: 100%;
      }

      /deep/.el-input__inner {
        border-color: rgba(204, 206, 221, 0.5);
        background: #2b3842;
        color: #fff;
      }

      /deep/.el-textarea__inner {
        border-color: rgba(204, 206, 221, 0.5);
        background: rgba(43, 56, 66, 1);
        color: #fff;
      }

      // 统一按钮
      .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
      }

      .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
      }

      // 设备调试返回值
      .debug-return {
        border: 1px solid rgba(204, 206, 221, 0.5);
        border-radius: 4px;
        padding: 0 8px 5px;
        background: rgba(43, 56, 66, 1);

        /deep/.el-textarea__inner {
          border: none;
          background: rgba(43, 56, 66, 1);
          color: #fff;
        }

        /deep/ .return-tool {
          border-bottom: 1px dashed rgba(204, 206, 221, 0.5);
          text-align: right;

          .btn:hover {
            color: @primaryTextColor;

            .ico-clear {
              background: url(../../../assets/img/general/Icon_Debug_Delete_Dark.png);
            }

            .ico-copy {
              background: url(../../../assets/img/general/Icon_Debug_Copy_Dark.png);
            }
          }

          .btn {
            padding: 0px;
            color: rgba(235, 235, 235, 1);
            font-size: 12px;
            cursor: pointer;
          }

          .ico-clear {
            background: url(../../../assets/img/general/Icon_Debug_Delete.png);
          }

          .ico-copy {
            background: url(../../../assets/img/general/Icon_Debug_Copy.png);
          }

          .ico {
            display: inline-block;
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            vertical-align: middle;
          }
        }
      }
    }
  }

  // 日月元透传升级
  // .upgradeInfo{
  //   height: 100%;
  //   // display: flex;
  //   // flex-direction: column;
  //   .deviceHeader{
  //     display: flex;
  //     font-size: 20px;
  //     color: #ffffff;
  //     justify-content: space-between;
  //     align-items: center;
  //     background-color: #222d35;
  //     .deviceHeaderLeft{
  //       display: flex;
  //       justify-content: flex-start;
  //       align-items: center;
  //       div:last-child{
  //         padding-left: 16px;
  //         font-weight: 700;
  //       }
  //       .closepage {
  //         display: inline-block;
  //         background-color: #23323D;
  //         width: 60px;
  //         height:56px;
  //         background-image: url('../../../assets/img/general/arrow_left.png');
  //         background-size: 24px 24px;
  //         background-repeat: no-repeat;
  //         background-position: center;
  //         cursor: pointer;
  //       }
  //     }
  //     .deviceHeaderRight{
  //       button{
  //         border: none;
  //         height: 56px;
  //         padding: 0 17px 0 12px;
  //         background-color: @primaryTextColor;
  //         color: #222D35;
  //         border-radius: 0;
  //       }
  //     }

  //   }
  //   .deviceBody{
  //     margin-top: 15px;
  //     display: grid;
  //     grid-template-columns: 1fr 1fr 4px 1fr 1fr;
  //     grid-template-rows: auto auto auto auto auto auto auto auto;
  //     grid-template-areas:
  //       "a1 a1 a1 a1 a1"
  //       "a11 a12 ss1 a13 a14"
  //       "a2 a2 a2 a2 a2"
  //       "a21 a22 ss2 a23 a24"
  //     ;
  //     .title {
  //       line-height: 46px;
  //       padding: 0px 20px;
  //       background: rgba(65, 80, 90, 1);
  //       color: rgba(235, 235, 235, 1);
  //       font-weight: bold;
  //       font-size: 16px;
  //       position: relative;
  //     }
  //     // 分割竖盒VBox
  //     .splitVBox {
  //       width: 4px;
  //       height: 100%;
  //       background: #222d35;
  //       border-left: 1px solid rgba(198, 209, 221, 0.3);
  //       border-right: 1px solid rgba(198, 209, 221, 0.3);
  //     }
  //     // 分割横线H
  //     .splitHLine {
  //       border-bottom: 1px solid rgba(198, 209, 221, 0.3);
  //     }
  //     .dark {
  //       background: rgb(34, 45, 53);
  //     }

  //     .light {
  //       background: rgb(43, 56, 66);
  //     }
  //     .cell {
  //       display: flex;
  //       align-items: center;
  //       line-height: 24px;
  //       padding: 0px 16px;
  //       box-shadow: none;
  //       color: rgba(255, 255, 255, 0.8);
  //       font-size: 12px;
  //       height: 56px;
  //     }
  //     .ggTitle1 {
  //       grid-area: a1;
  //     }
  //     .ggCell11 {
  //       grid-area: a11;
  //     }

  //     .ggCell12 {
  //       grid-area: a12;
  //     }

  //     .ggCell13 {
  //       grid-area: a13;
  //     }

  //     .ggCell14 {
  //       grid-area: a14;
  //     }
  //     .ggTitle2 {
  //       grid-area: a2;
  //     }
  //     .ggCell21 {
  //       grid-area: a21;
  //     }

  //     .ggCell22 {
  //       grid-area: a22;
  //     }

  //     .ggCell23 {
  //       grid-area: a23;
  //     }

  //     .ggCell24 {
  //       grid-area: a24;
  //     }
  //     // 分割竖盒
  //     .ggCell01 {
  //       grid-area: ss1;
  //     }

  //     .ggCell02 {
  //       grid-area: ss2;
  //     }
  //   }
  // }

  .deviceNewTable {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  background-color: rgba(45, 63, 75, 1);
  margin: 20px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex-direction: column;

  // border-radius: 4px;
  // 加载动画
  //固定列遮挡最后一列边框
  /deep/ .el-table__row {
    td:not(.is-hidden):last-child {
      right: -6px;
    }
  }

  /deep/ .el-table__header {
    th:not(.is-hidden):last-child {
      right: -6px;
    }
  }

  &.tableloding {

    // 遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, 0.5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }

  // 可点击跳转的标题
  .redirect {
    color: @primaryTextColor;
  }

  // 统一按钮系列
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .elbtn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    line-height: normal;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btnbox {
    .el-btn {
      margin-left: 0;
    }

    .el-button.is-disabled {
      background-color: #83c2ab;
      color: rgb(104, 104, 104);
    }
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .devicetop {
    display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    // align-items: center;
    padding: 0px 0px;
    margin-bottom: 20px;

    // background: rgba(34, 45, 53, 1);
    // align-self: flex-end;
    // .devicename {
    //   font-size: 16px;
    //   font-weight: bold;
    //   color: #333;
    //   letter-spacing: 1.5px;
    // }
    .status-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: left;

      li {
        padding: 14px 0px 7px 10px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        background: rgba(34, 45, 53, 1);
        margin-right: 8px;
        position: relative;

        div {
          width: 100%;
        }

        div:last-child {
          line-height: 35px;
        }

        div:first-child {
          display: flex;
          align-items: center;
          line-height: 20px;
          padding: 0 0 6px 2px;

          i {
            font-size: 18px;
          }

          span {
            margin-left: 12px;
            color: #adb9c0;
          }
        }

        .nibianqi {
          position: absolute;
          top: 22px;
          right: 0;
        }

        .nibianqi {
          box-sizing: border-box;
          width: 65px;
          height: 58px;
          overflow: hidden;
          position: absolute;

          .icon-a-mingchengnibianqi1 {
            color: rgba(67, 85, 98, 0.2);
            display: inline-block;
            font-size: 74px;
            transform: rotate(-14.5deg);
            left: 8px;
            top: -3px;
          }
        }
      }

      li:last-child {
        margin-right: 0;
      }
    }
  }

  // .search {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;
  //   .button-create {
  //     float: right;
  //   }
  // }
  // .sections
  .section {
    // margin: 0 24px;
    // flex: 1;
    // display: flex;
    // flex-direction: column;
    // overflow: hidden;

    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    // overflow: auto;
    overflow: hidden;

    /deep/ .moreDeviceDialog {
      border: 1px solid rgba(17, 104, 99, 1);
    }

    /deep/ .moreDeviceDialog .el-dialog__header {
      background: rgb(34, 45, 53) !important;
      color: #ffffff;
      position: relative;
      height: 60px;
      padding: 0 20px;
      // border-bottom: 1px solid @borderColor;
      border-bottom: 1px solid rgba(17, 104, 99, 1);
      display: flex;
      // justify-content: center;
      // text-align:center;
      align-items: center;
      background: linear-gradient(-135deg,
          transparent 30px,
          rgba(34, 45, 53, 1) 0);
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;

      .el-dialog__title {
        color: #fff;
      }

      .sc(16px, rgba(163, 199, 215, 1));

      // font-weight: bold;
      i {
        position: absolute;
        top: 7px;
        right: 5px;
        .sc(14px, #16d09a);
        cursor: pointer;
        // &:hover {
        //   color: @hoverColor;
        // }
      }
    }

    /deep/ .moreDeviceDialog .el-dialog__body {
      background: rgb(34, 45, 53);
      padding: 30px 35px;
      overflow: auto;
      max-height: 85vh;
      display: flex;
      flex-direction: column;

      .content_tishi {
        text-align: center;

        .tital {
          display: flex;
          align-items: center;
          justify-content: center;

          .contentdelete {
            // font-size: 20px;
            // font-weight: 600;
            font-size: 18px;
            color: rgba(255, 62, 62, 1);
            font-weight: bold;
          }

          i {
            font-size: 30px;
            margin-right: 10px;
          }
        }
      }

      .disabledescr {
        // margin-left: 40px;
        display: flex;
        justify-content: center;
        // margin-top: 10px;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
      }

      .deletfotter {
        margin-top: 50px;

        .button-hollow {
          width: 100px;
          height: 32px;
          margin: 0 6px;
        }

        .button-solid {
          margin: 0 6px;
          width: 100px;
          height: 32px;
        }
      }

      // 关闭删除弹框
      .contentClose {
        position: absolute;
        top: 7px;
        right: 5px;
        .sc(14px, #16d09a);
        cursor: pointer;
      }
    }

    .moreDeviceDialog .el-dialog__footer {
      background: rgba(34, 45, 53, 1);
      height: 60px;
      padding: 0 20px;
      // border-top: 1px solid @borderColor;
      border-top: 1px solid rgba(17, 104, 99, 1);
      display: flex;
      justify-content: flex-end;
      // justify-content: center;
      align-items: center;

      .button {
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 5px;
        // min-width: 100px;
        cursor: pointer;
        margin: 0 6px;
        background-color: #16d09a;
        color: #202d35;
        border: none;
      }

      .button-hollow {
        border-radius: 5px;
        .sc(14px, #666);
        border-color: #ddd;
        .button;

        &:hover {
          background: #f8f9fa;
        }
      }

      .button-solid {
        .button;
      }
    }

    .chongzhi {
      .juxing {
        display: inline-block;
        width: 100px;
        height: 10px;
        border: 0px solid #fff;
        margin-left: 5px;
      }

      .inputlo {
        margin-bottom: -16px;
        min-height: 20px;
        width: 100%;
      }

      .input_spans,
      .pwd_span,
      .email_span,
      .phone_span,
      .confpwd_span {
        min-height: 20px;
        line-height: 20px;
        color: #f56c6c;
        font-size: 12px;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
      }

      .input_span {
        height: 20px;
        line-height: 20px;
      }

      .sucess {
        min-height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #999;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
        // font-family: "Microsoft YaHei";
      }

      /deep/ .el-form-item__error {
        display: none;
      }
    }

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        // right: 167px;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 500px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 320px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .search-alert1 {
        position: absolute;
        top: 0;
        // left: 0;
        right: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-input:not(:last-child) {
        margin-right: 0px;
      }

      /deep/.el-select:not(:last-child) {
        margin-right: 0px;
      }

      // .searchLeft {}
      .searchRight {
        display: flex;
        justify-content: flex-end;

        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222d35;
          border-radius: 0;

          span {
            padding-left: 5px;
          }
        }
      }

      // 导出报表
      .button-export {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 16px;
        // margin-right: 20px;
        // border-radius: 4px;
        // background: var(--theme-color);
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        cursor: pointer;
        height: 48px;

        .ico-download {
          width: 16px;
          height: 16px;
          background: url(../../../assets/img/general/Icon_Download.png) no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 10px;
        }
      }
    }

    .table {
      flex: 1;
      overflow: auto;

      /deep/.el-icon-loading {
        font-size: 28px;
      }
    }

    // .tablebottom {
    //   align-self: flex-end;
    //   // text-align: center;
    //   margin-bottom: 10px;
    // }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      // 关注标记
      .followSign {
        width: 0;
        height: 0;
        border-top: 8px solid rgba(236, 206, 48, 1);
        border-left: 8px solid transparent;
      }

      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
        z-index: 9999;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }

      // 关于表格右侧边线(无效)
      /deep/.el-table--border::after {
        display: none;
      }

      /deep/.el-table--group::after {
        display: none;
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  .active {
    color: #26ae3c;
  }

  .inactive {
    color: #c9c9c9;
  }

  .upload-input {
    display: none;
  }

  .contentdelete {
    font-size: 20px;
    font-weight: 600;
  }

  .deletfotter {
    margin-top: 50px;

    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }

    .button-solid {
      width: 100px;
      height: 35px;
    }
  }

  .status-container {
    display: flex;
    align-items: center;

    // justify-content: space-between;
    .status {
      border-radius: 25px;
      box-shadow: 0px -1px 2.5px #7f7f7f;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
      padding: 0px 20px;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      // border: 1px solid #000;
      border-radius: 18px;
      box-shadow: inset 0px 0px 5px 1px #ccc;

      &-num {
        color: #333;
        font-size: 16px;
      }

      &-label {
        color: #333;
        font-size: 16px;
      }

      &-icon {
        width: 10px;
        height: 10px;
        margin-right: 3px;
      }
    }

    // 设备状态表新版
    .color {
      .nibianqi {
        box-sizing: border-box;
        width: 55px;
        height: 48px;
        overflow: hidden;
        position: relative;

        .icon-a-mingchengnibianqi1 {
          display: inline-block;
          font-size: 64px;
          transform: rotate(-14.5deg);
          position: absolute;
          left: 8px;
          top: -3px;
        }
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      // height: 32px;
      // line-height: 32px;
      // margin-right: 10px;
      // padding: 0px 20px;
      // border-radius: 25px;
      // background-color: #fff;
      // border-radius: 18px;
      // box-shadow: 0px -1px 2.5px #000000;
      // box-shadow: inset 0px 0px 5px 1px #ccc;
      // border: 1px solid #000;
      &-num {
        // color: #333;
        font-size: 25px;
      }

      &-label {
        display: flex;
        align-items: center;
        color: #adb9c0;
        font-size: 14px;

        // margin-right: 10px;
        i {
          font-size: 22px;
          margin-right: 10px;
        }

        span {
          line-height: 22px;
        }
      }

      // &-icon {
      //   width: 22px;
      //   height: 22px;
      //   margin-right: 10px;
      // }
      &-normal {
        color: rgba(48, 236, 112, 1);
      }

      &-offline {
        color: rgba(183, 183, 183, 1);
      }

      &-fault {
        color: rgba(255, 62, 62, 1);
      }

      &-standby {
        color: rgba(73, 222, 255, 1);
      }

      &-warning {
        color: rgba(236, 150, 48, 1);
      }
    }
  }

  //批量设备升级样式
  .upgardeControl {
    /deep/.el-table th>.cell {
      font-weight: 400;
    }

    /deep/.el-table tr {
      background-color: #222d35;
    }

    /deep/.el-table th.is-leaf {
      border-right: 1px solid rgba(102, 102, 102, 0.5);
      border-bottom: 1px solid rgba(102, 102, 102, 0.5);
    }

    /deep/.el-table td {
      border-right: 1px solid rgba(102, 102, 102, 0.5);
      border-bottom: 1px solid rgba(102, 102, 102, 0.5);
    }

    /deep/.el-table__body tr.hover-row td {
      background-color: rgba(48, 208, 150, 0.15);
    }
  }

  //控制权限里面的样式
  .editControl {
    margin-top: -20px;
    margin-bottom: -2px;
    display: flex;
    flex: 1;
    flex-direction: column;

    /deep/ .el-checkbox__inner::after {
      top: 1px;
      left: 4px;
    }

    .searchprotocol {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;

      .searchName {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        text-align: right;
        width: 180px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
      }

      .el-select {
        margin-left: 0px;
        width: 500px;
      }
    }

    .personProtocol,
    .adminProtocol {
      display: flex;
      flex-direction: row;
      min-height: 180px;

      .contentLeft {
        flex: 1;
        font-family: "Times New Roman", "Microsoft YaHei";
        font-size: 16px;
        letter-spacing: 1.5px;
        height: 100%;
        width: 180px;
        color: rgba(255, 255, 255, 0.7);

        .top {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          text-align: right;
          font-size: 14px;

          .protocolTitle {
            width: 180px;
          }

          /deep/.el-checkbox {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }

          /deep/.el-checkbox__label {
            color: rgba(255, 255, 255, 1);
            width: auto;
            font-size: 14px;
            height: 100%;
          }

          /deep/.el-checkbox__inner {
            width: 14px;
            height: 14px;
            border-radius: 4px;
            border: 1px solid rgba(190, 190, 190, 1);
            background: rgba(255, 255, 255, 1);
          }

          /deep/.el-checkbox__inner:hover,
          /deep/.el-checkbox__inner:focus {
            border: 1px solid rgba(51, 255, 182, 1);
          }

          /deep/.el-checkbox {
            margin-right: 10px;
            margin-top: 30px;
          }

          /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
            border: 1px solid rgba(51, 255, 182, 1);
            background: @primaryTextColor;
          }
        }
      }

      .contentRight {
        flex: 7;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        display: flex;
        flex-direction: column;

        .noData {
          margin: 40px auto;
          font-size: 14px;
          color: #909399;
        }

        .protoclContents {
          flex: 1;
          max-height: 300px;
          overflow: auto;

          .checkboxUnit {
            // font-family: "微软雅黑";
            // padding-left: 6px;
            padding: 10px;
            margin: 0;

            // border-right: 0.5px solid #eee;
            /deep/.el-checkbox__label {
              color: rgba(255, 255, 255, 1);
              font-size: 14px !important;
              padding-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 136px !important;
              padding-top: 5px;
            }

            /deep/.el-checkbox__inner:hover,
            /deep/.el-checkbox__inner:focus {
              border: 1px solid rgba(51, 255, 182, 1);
            }

            /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
              border: 1px solid rgba(51, 255, 182, 1);
              background: @primaryTextColor;
            }

            /deep/.el-checkbox__input {
              height: 23px;
              line-height: normal;
            }

            /deep/.el-checkbox__label {
              height: 23px;
            }
          }
        }

        /deep/.el-checkbox__inner {
          width: 14px;
          height: 14px;
          border-radius: 4px;
          border: 1px solid rgba(190, 190, 190, 1);
          background: rgba(255, 255, 255, 1);
        }

        // 滚动条
        ::-webkit-scrollbar {
          width: 3px;
          height: 3px;
          background-color: transparent;
        }
      }
    }

    .adminProtocol {
      margin-top: 15px;
    }
  }

  // 控制弹框
  .control {
    .tableBackgruond {
      background-color: #222d35;
    }

    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 16px;
        }

        padding: 5px 12px;
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 1);
      }
    }

    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: @primaryTextColor;
      }
    }

    /deep/.el-input .el-input__inner {
      border: none;
    }

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: #ffffff;
      padding: 0px 10px;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
      border: none;
    }

    // /deep/.el-button,
    // /deep/.el-button:focus,
    // /deep/.el-button:hover {
    // 	background: transparent;
    // 	border: none;
    // 	color: @primaryTextColor;
    // }
    // 表头
    /deep/.el-table th {
      border: none;
      box-shadow: 0px 1px rgba(255, 255, 255, 0.25) inset,
        0px -1px rgba(255, 255, 255, 0.25) inset;
    }

    /deep/.el-table--border,
    /deep/.el-table--group {
      border: none;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    // 间距
    /deep/ .el-table__body {
      border-collapse: separate;
      border-spacing: 10px;
      table-layout: auto !important;
      background: rgba(34, 45, 53, 1);
    }
  }

  .el-table--border::after,
  .el-table--group::after {
    width: 0px;
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    // background-color: #222d35;
    background-color: transparent;
  }

  // ::-webkit-scrollbar-thumb {
  //   background: rgba(180, 184, 193, 1);
  //   border-radius: 3px;
  // }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // display: inline-block;
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Batch_Copy.png);
      }

      .ico-export {
        background: url(../../../assets/img/general/Icon_Batch_Export.png);
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Batch_Delete.png);
      }

      .ico-upgrade {
        background: url(../../../assets/img/general/Icon_Batch_Upgrade.png);
      }

      .ico-more {
        background: url(../../../assets/img/general/Icon_Batch_More.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }

      // 批量更多下拉 (不可scoped)(.dropdown-more)
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

// 固件升级状态窗
.upgradeNew {
  /deep/.el-radio__input.is-checked .el-radio__inner {
    background: #15c491;
    background-color: #15c491;
    border-color: #15c491;
  }

  /deep/.el-radio__input.is-checked+.el-radio__label {
    color: #15c491;
  }

  .processstatue,
  .processstatueEquipment {
    font-size: 16px;
    color: #16d09a;
  }

  .processstatue,
  .processstatueEquipment1 {
    font-size: 16px;
    color: #ff3e3e;
  }

  /deep/.el-progress__text {
    color: #ffffff;
  }

  .progerssComplete,
  .progerssCompleteEquipment {
    background: transparent;
  }

  // 升级完成显示已完成的设备列表
  .progerssCompleteEquipment {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0px;
    align-items: flex-start;

    .progressName {
      margin-left: 0px;
    }
  }

  // 遮罩
  /deep/.el-loading-mask {
    background-color: rgb(34, 45, 53, 0.5);
  }

  // 花形
  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
  }

  // 环形
  /deep/.el-loading-spinner .path {
    stroke: @primaryTextColor;
  }
}
</style>
<style lang="less">
.moreChildDeviceDialog {
  .el-form-item__label {
    color: #fff;
    height: 100%;
  }

  .el-input__inner {
    border-color: rgba(204, 206, 221, 0.5);
    background: #2b3842;
    color: #fff;
  }

  .el-textarea__inner {
    border-color: rgba(204, 206, 221, 0.5);
    background: rgba(43, 56, 66, 1);
    color: #fff;
  }

  border: 1px solid rgba(17, 104, 99, 1);

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }
}

.moreChildDeviceDialog .el-dialog__header {
  background: rgb(34, 45, 53) !important;
  color: #ffffff;
  position: relative;
  height: 60px;
  padding: 0 20px;
  // border-bottom: 1px solid @borderColor;
  border-bottom: 1px solid rgba(17, 104, 99, 1);
  display: flex;
  // justify-content: center;
  // text-align:center;
  align-items: center;
  background: linear-gradient(-135deg, transparent 30px, rgba(34, 45, 53, 1) 0);
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .el-dialog__title {
    color: #fff;
  }

  // .sc(16px, rgba(163, 199, 215, 1));

  // font-weight: bold;
  i {
    position: absolute;
    top: 7px;
    right: 5px;
    // .sc(14px, #16D09A);
    cursor: pointer;
    // &:hover {
    //   color: @hoverColor;
    // }
  }
}

.moreChildDeviceDialog .el-dialog__body {
  background: rgb(34, 45, 53);
  padding: 30px 35px;
  overflow: auto;
  max-height: 85vh;
  display: flex;
  flex-direction: column;

  .content_tishi {
    text-align: center;

    .tital {
      display: flex;
      align-items: center;
      justify-content: center;

      .contentdelete {
        // font-size: 20px;
        // font-weight: 600;
        font-size: 18px;
        color: rgba(255, 62, 62, 1);
        font-weight: bold;
      }

      i {
        font-size: 30px;
        margin-right: 10px;
      }
    }
  }

  .disabledescr {
    // margin-left: 40px;
    display: flex;
    justify-content: center;
    // margin-top: 10px;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
  }

  .deletfotter {
    margin-top: 50px;

    .button-hollow {
      width: 100px;
      height: 32px;
      margin: 0 6px;
    }

    .button-solid {
      margin: 0 6px;
      width: 100px;
      height: 32px;
    }
  }

  // 关闭删除弹框
  .contentClose {
    position: absolute;
    top: 7px;
    right: 5px;
    // .sc(14px, #16D09A);
    cursor: pointer;
  }
}

.moreChildDeviceDialog .el-dialog__footer {
  background: rgba(34, 45, 53, 1);
  height: 0px;
  padding: 0 20px;
}

// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 0px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    // width: 0px;
    // height: 0px;
    background-color: transparent;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(164, 182, 200, 0.2);
  }
}

// 控制项日期选择样式
.select-date .el-input .el-input__inner,
.select-date .el-picker-panel__footer {
  background: #222d35;
}

.select-date .el-button {
  background: #222d35;
  color: @primaryTextColor;

  &:hover {
    background: #222d35;
    color: @primaryTextColor;
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

.deviceName .el-tooltip {
  color: @primaryTextColor;
}
</style>

<style lang="less">
// 统一给表格分页器增加宽度（国际化显示问题）
.tablebottom {

  // 分页
  .pagination {
    .el-pagination__sizes {
      .el-select {
        .el-input {
          min-width: 150px !important;
        }
      }
    }
  }
}
</style>
